import React, { useEffect, useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { connect } from "react-redux";
import Notiflix from "notiflix";

import {
  Input,
  Row,
  Card,
  Form,
  Statistic,
  Checkbox,
  Col,
  Divider,
  Spin,
  Table,
  Typography,
  Layout,
  Collapse,
  Select,
  DatePicker,
  InputNumber,
  Button,
  Modal,
  Tooltip,
  List,
} from "antd";
import {
  PlusOutlined,
  DeleteOutlined,
  FolderOpenOutlined,
  DownloadOutlined,
} from "@ant-design/icons";
import { RightOutlined, DownOutlined } from "@ant-design/icons";
import { BOM } from "../../../../services/definedMethod";
import cnt from "../../../../services/definedConstant";
import CustomButton from "../../../../components/custom/CustomButton";
import MainLayout from "../../../../components/layouts/MainLayout";
import TopContent from "../../../../components/layouts/TopContent";
import definedApi from "../../../../services/definedApi";

import {
  apiConfig,
  labelConfig,
  staticConfig,
} from "../../../customer/customer.config";
import styles from "../../../../assets/styles/styles";
import appLabel from "../../../../config/appLabel";

const { TextArea } = Input;
const { Text, Title } = Typography;

const EditLoanProduct = (props) => {
  //DECLARED VARIABLES
  const {
    userData,
    onChange,
    handleCanDefineInstallmentAmount,
    handleMapFeeDelete,
    handleMapPenaltyDelete,
    handleIncludeInBorrowerCycle,
    includeInBorrowerCycle,
    canUseForTopup,
    handleAccountMovesOutOfNPAOnlyOnArrearsCompletion,
    accountMovesOutOfNPAOnlyOnArrearsCompletion,
    canDefineInstallmentAmount,
    repaymentPeriod,
    onRepaymentPeriodSelect,
    isEqualAmortization,
    handleIsEqualAmortization,
    handleIsArrearsBasedOnOriginalSchedule,
    handleCanUseForTopup,
  } = props;
  const { session } = userData;
  const navigate = useNavigate();
  const [useForm] = Form.useForm();
  const { state } = useLocation();
  const [isLoading, setIsLoading] = useState(false);

  const recalculateInterestCheck = Form.useWatch(
    "isInterestRecalculationEnabled",
    useForm
  );
  const guaranteeRequirementsCheck = Form.useWatch(
    "holdGuaranteeFunds",
    useForm
  );
  const multipleDisbursalsCheck = Form.useWatch("multiDisburseLoan", useForm);
  const variableInstallmentsChecked = Form.useWatch(
    "allowVariableInstallments",
    useForm
  );

  // CHARGES FORM REQURED VARIABLES
  const [fundCount, setFundCount] = useState(1);
  const [feeCount, setFeeCount] = useState(0);
  const [count, setCount] = useState(1);
  const [chargeTableSource, setChargeTableSource] = useState([]);
  const [configureFundTableSource, setConfigureFundTableSource] = useState([]);
  const [mapFeeTableSource, setMapFeeTableSource] = useState([]);
  const [mapPenaltyTableSource, setMapPenaltyTableSource] = useState([]);

  // ENDPOINT DECLARED VARIABLES
  const [fundsData, setFundsData] = useState([]);
  const [currencyData, setCurrencyData] = useState([]);
  const [amortizationData, setAmortizationData] = useState([]);
  const [interestTypeData, setInterestTypeData] = useState([]);
  const [
    interestCalculationPeriodTypeData,
    setInterestCalculationPeriodTypeData,
  ] = useState([]);
  const [daysInYearData, setDaysInYearData] = useState([]);
  const [daysInMonthData, setDaysInMonthData] = useState([]);
  const [
    preClosureInterestCalculationStrategy,
    setPreClosureInterestCalculationStrategy,
  ] = useState([]);
  const [rescheduleStrategyType, setRescheduleStrategyType] = useState([]);
  const [
    interestRecalculationCompoundingType,
    setInterestRecalculationCompoundingType,
  ] = useState([]);
  const [recalculationRestFrequencyType, setRecalculationRestFrequencyType] =
    useState([]);
  const [
    transactionProcessingStrategyOptions,
    setTransactionProcessingStrategyOptions,
  ] = useState([]);
  const [
    interestRecalculationFrequencyTypeOptions,
    setinterestRecalculationFrequencyTypeOptions,
  ] = useState([]);
  const [
    interestRecalculationDayOfWeekTypeOptions,
    setInterestRecalculationDayOfWeekTypeOptions,
  ] = useState([]);
  const [
    interestRecalculationNthDayTypeOptions,
    setInterestRecalculationNthDayTypeOptions,
  ] = useState([]);
  const [floatingRateOptions, setFloatingRateOptions] = useState([]);
  const [loanProductDetails, setLoanProductDetails] = useState([]);

  const [repaymentFrequencyTypeOptions, setRepaymentFrequencyTypeOptions] =
    useState([]);
  const [
    interestRateFrequencyTypeOptions,
    setInterestRateFrequencyTypeOptions,
  ] = useState([]);
  const [accountingRuleOptions, setAccountingRuleOptions] = useState([]);
  const [valueConditionTypeOptions, setValueConditionTypeOptions] = useState(
    []
  );
  const [chargeOptions, setChargeOptions] = useState([]);
  const [chargeList, setChargeList] = useState([]);
  const [interestRateByLoanCycleSource, setInterestRateByLoanCycleSource] =
    useState([]);
  const [principalByLoanCycleSource, setPrincipalByLoanCycleSource] = useState(
    []
  );
  const [repaymentsByLoanCycleSource, setRepaymentsByLoanCycleSource] =
    useState([]);

  const [charges, setCharges] = useState([]);
  const [chargesOptions, setChargesOptions] = useState([]);
  const [chargeBasedOnCurrencyList, setChargeBasedOnCurrencyList] = useState(
    []
  );
  const [assetAccountOptions, setAssetAccountOptions] = useState([]);
  const [expenseAccountOptions, setExpenseAccountOptions] = useState([]);
  const [incomeAccountOptions, setIncomeAccountOptions] = useState([]);
  const [liabilityAccountOptions, setLiabilityAccountOptions] = useState([]);
  const [paymentTypeOptions, setPaymentTypeOptions] = useState([]);
  const [penaltyOptions, setPenaltyOptions] = useState([]);

  const [isChargeModalOpen, setIsChargeModalOpen] = useState(false);
  const [isFundSourceModalOpen, setIsFundSourceModalOpen] = useState(false);
  const [isMapFeeModalOpen, setIsMapFeeeModalOpen] = useState(false);
  const [allowAttributeConfiguration, setAllowAttributeConfiguration] =
    useState(false);
  const [amortization, setAmortization] = useState(true);
  const [transactionProcessingStrategy, setTransactionProcessingStrategy] =
    useState(true);
  const [arrearsTolerance, setArrearsTolerance] = useState(true);
  const [graceOnPrincipalAndInterest, setGraceOnPrincipalAndInterest] =
    useState(true);
  const [interestMethod, setInterestMethod] = useState(true);
  const [interestCalcPeriod, setInterestCalcPeriod] = useState(true);
  const [repaymentFrequency, setRepaymentFrequency] = useState(true);
  const [graceOnArrearsAging, setGraceOnArrearsAging] = useState(true);
  const [isLinkedToFloatingInterestRates, setIsLinkedToFloatingInterestRates] =
    useState(false);
  const [useBorrowerCycle, setUseBorrowerCycle] = useState(false);
  const [
    interestRecalculationCompounding,
    setInterestRecalculationCompounding,
  ] = useState(false);
  const [recalculationRestFrequency, setRecalculationRestFrequency] =
    useState(false);
  const [weeklyRecalculateFrequency, setWeeklyRecalculateFrequency] =
    useState(false);
  const [monthlyRecalculateFrequency, setMonthlyRecalculateFrequency] =
    useState(false);

  // ACCOUNTING FORM REQUIRED VARIABLES
  const [accountingRuleCheck, setAccountingRuleCheck] = useState("1");
  const [showAdvancedAccounting, setShowAdvancedAccounting] = useState(false);

  useEffect(() => {
    getDetailById(state);
  }, []);

  const onChangeCurrency = (currencyParam) => {
    const chargeForTableData = chargesOptions.filter(
      (item) => item.currencyCode === currencyParam
    );
    useForm.setFieldsValue({
      chargeId: "",
    });
    setChargeBasedOnCurrencyList([...chargeForTableData]);
  };

  const getDetailById = (params) => {
    const url = `${definedApi.GetLoanProductList}/${params.key}?template=true`;
    let body = {
      session,
    };

    BOM.FetchReqAction(body, url, (err, res) => {
      if (err) {
        BOM.AlertMsg(cnt.DANGER, err.defaultUserMessage);
      } else {
        const objDetail = res;
        setLoanProductDetails(objDetail);

        let tempFunds = [];
        let tempCurrency = [];
        let tempAmortization = [];
        let tempInterestType = [];
        let tempInterestCalculationPeriodType = [];
        let tempDaysInYearType = [];
        let tempDaysInMonthType = [];
        let tempPreClosureInterestCalculationStrategy = [];
        let tempRescheduleStrategyType = [];
        let tempInterestRecalculationCompoundingType = [];
        let tempRecalculationRestFrequencyType = [];
        let tempTransactionProcessingStrategy = [];
        let tempAccountingRuleOptions = [];
        let tempAssetAccountOptions = [];
        let tempIncomeAccountOptions = [];
        let tempExpenseAccountOptions = [];
        let tempLiabilityAccountOptions = [];
        let tempRepaymentFrequencyTypeOptions = [];
        let tempInterestRateFrequencyTypeOptions = [];
        let tempValueConditionTypeOptions = [];
        let tempinterestRecalculationFrequencyTypeOptions = [];
        let tempInterestRecalculationDayOfWeekTypeOptions = [];
        let tempInterestRecalculationNthDayTypeOptions = [];
        let tempCharges = [];
        let tempChargesList = [];
        let tempChargesOptions = [];
        let tempPenaltyOptions = [];
        let tempPaymentTypeOptions = [];
        let temPaymentChannelToFundSourceMappings = [];
        let tempFeeToIncomeAccountMappings = [];
        let tempPenaltyToIncomeAccountMappings = [];
        let tempFloatingRateOptions = [];

        useForm.setFieldsValue({
          name: objDetail?.name,
          shortName: objDetail?.shortName,
          fundId: objDetail?.fundId,
          // startDate: objDetail?.startDate? (`${objDetail?.startDate[2]} ${monthList[objDetail?.startDate[1] - 1]} ${objDetail?.startDate[0]}`) : "-",
          // closeDate: objDetail?.closeDate? (`${objDetail?.closeDate[2]} ${monthList[objDetail?.closeDate[1] - 1]} ${objDetail?.closeDate[0]}`) : "-",
          description: objDetail?.description,
          currencyCode: objDetail?.currency?.code,
          digitsAfterDecimal: objDetail.currency.decimalPlaces,
          inMultiplesOf: objDetail?.currency.inMultiplesOf,
          installmentAmountInMultiplesOf:
            objDetail?.installmentAmountInMultiplesOf,
          includeInBorrowerCycle: objDetail?.includeInBorrowerCycle,
          minPrincipal: objDetail?.minPrincipal,
          principal: objDetail?.principal,
          maxPrincipal: objDetail?.maxPrincipal,
          minNumberOfRepayments: objDetail?.minNumberOfRepayments,
          numberOfRepayments: objDetail?.numberOfRepayments,
          maxNumberOfRepayments: objDetail?.maxNumberOfRepayments,
          minInterestRatePerPeriod: objDetail?.minInterestRatePerPeriod,
          interestRatePerPeriod: objDetail?.interestRatePerPeriod,
          maxInterestRatePerPeriod: objDetail?.maxInterestRatePerPeriod,
          interestRateFrequencyType: objDetail?.interestRateFrequencyType.id,
          repaymentEvery: objDetail?.repaymentEvery,
          repaymentFrequencyType: objDetail?.repaymentFrequencyType.id,
          minimumDaysBetweenDisbursalAndFirstRepayment:
            objDetail?.minimumDaysBetweenDisbursalAndFirstRepayment,
          isLinkedToFloatingInterestRates:
            objDetail?.isLinkedToFloatingInterestRates,
          useBorrowerCycle: objDetail?.useBorrowerCycle,
          amortizationType: objDetail?.amortizationType.id,
          interestType: objDetail?.interestType.id,
          interestCalculationPeriodType:
            objDetail?.interestCalculationPeriodType.id,
          transactionProcessingStrategyId:
            objDetail?.transactionProcessingStrategyId,
          graceOnPrincipalPayment: objDetail?.graceOnPrincipalPayment,
          graceOnInterestPayment: objDetail?.graceOnInterestPayment,
          graceOnInterestCharged: objDetail?.graceOnInterestCharged,
          inArrearsTolerance: objDetail?.inArrearsTolerance,
          daysInYearType: objDetail?.daysInYearType.id,
          daysInMonthType: objDetail?.daysInMonthType.id,
          allowVariableInstallments: objDetail?.allowVariableInstallments,
          principalThresholdForLastInstallment:
            objDetail?.principalThresholdForLastInstallment,
          preClosureInterestCalculationStrategy:
            objDetail?.interestRecalculationData
              ?.preClosureInterestCalculationStrategy?.id,
          rescheduleStrategyMethod:
            objDetail?.interestRecalculationData?.rescheduleStrategyType?.id,
          interestRecalculationCompoundingMethod:
            objDetail?.interestRecalculationData
              ?.interestRecalculationCompoundingType?.id,
          recalculationRestFrequencyType:
            objDetail?.interestRecalculationData?.recalculationRestFrequencyType
              ?.id,
          recalculationRestFrequencyInterval:
            objDetail?.interestRecalculationData
              ?.recalculationRestFrequencyInterval,
          isArrearsBasedOnOriginalSchedule:
            objDetail?.interestRecalculationData
              ?.isArrearsBasedOnOriginalSchedule,

          holdGuaranteeFunds: objDetail?.holdGuaranteeFunds,
          multiDisburseLoan: objDetail?.multiDisburseLoan,
          mandatoryGuarantee:
            objDetail?.productGuaranteeData?.mandatoryGuarantee,
          minimumGuaranteeFromOwnFunds:
            objDetail?.productGuaranteeData?.minimumGuaranteeFromOwnFunds,
          minimumGuaranteeFromGuarantor:
            objDetail?.productGuaranteeData?.minimumGuaranteeFromGuarantor,
          maxTrancheCount: objDetail?.maxTrancheCount,
          outstandingLoanBalance: objDetail?.outstandingLoanBalance,
          isInterestRecalculationEnabled:
            objDetail?.isInterestRecalculationEnabled,
          fundSourceAccountId:
            objDetail?.accountingMappings?.fundSourceAccount?.id,
          loanPortfolioAccountId:
            objDetail?.accountingMappings?.loanPortfolioAccount?.id,
          transfersInSuspenseAccountId:
            objDetail?.accountingMappings?.transfersInSuspenseAccount?.id,
          interestOnLoanAccountId:
            objDetail?.accountingMappings?.interestOnLoanAccount?.id,
          incomeFromFeeAccountId:
            objDetail?.accountingMappings?.incomeFromFeeAccount?.id,
          incomeFromPenaltyAccountId:
            objDetail?.accountingMappings?.incomeFromPenaltyAccount?.id,
          incomeFromRecoveryAccountId:
            objDetail?.accountingMappings?.incomeFromRecoveryAccount?.id,
          writeOffAccountId: objDetail?.accountingMappings?.writeOffAccount?.id,
          overpaymentLiabilityAccountId:
            objDetail?.accountingMappings?.overpaymentLiabilityAccount?.id,
        });

        // STRICT VALUES FOR ACCOUNTING FORM
        let tempAccountingRule = "" + objDetail?.accountingRule?.id;
        setAccountingRuleCheck(tempAccountingRule);

        // ATTACHING OPTIONS FROM END POINT
        objDetail?.fundOptions?.forEach((element) => {
          tempFunds.push({
            value: element.id,
            label: element.name,
          });
        });

        objDetail?.currencyOptions?.forEach((element) => {
          tempCurrency.push({
            value: element.code,
            label: element.displayLabel,
          });
        });

        objDetail?.amortizationTypeOptions?.forEach((element) => {
          tempAmortization.push({
            value: element.id,
            label: element.value,
          });
        });

        objDetail?.interestTypeOptions?.forEach((element) => {
          tempInterestType.push({
            value: element.id,
            label: element.value,
          });
        });

        objDetail?.interestCalculationPeriodTypeOptions?.forEach((element) => {
          tempInterestCalculationPeriodType.push({
            value: element.id,
            label: element.value,
          });
        });

        objDetail?.daysInYearTypeOptions?.forEach((element) => {
          tempDaysInYearType.push({
            value: element.id,
            label: element.value,
          });
        });

        objDetail?.daysInMonthTypeOptions?.forEach((element) => {
          tempDaysInMonthType.push({
            value: element.id,
            label: element.value,
          });
        });

        objDetail?.preClosureInterestCalculationStrategyOptions?.forEach(
          (element) => {
            tempPreClosureInterestCalculationStrategy.push({
              value: element.id,
              label: element.value,
            });
          }
        );

        objDetail?.rescheduleStrategyTypeOptions?.forEach((element) => {
          tempRescheduleStrategyType.push({
            value: element.id,
            label: element.value,
          });
        });

        objDetail?.interestRecalculationCompoundingTypeOptions?.forEach(
          (element) => {
            tempInterestRecalculationCompoundingType.push({
              value: element.id,
              label: element.value,
            });
          }
        );

        objDetail?.interestRecalculationFrequencyTypeOptions?.forEach(
          (element) => {
            tempRecalculationRestFrequencyType.push({
              value: element.id,
              label: element.value,
            });
          }
        );

        objDetail?.transactionProcessingStrategyOptions?.forEach((element) => {
          tempTransactionProcessingStrategy.push({
            value: element.id,
            label: element.name,
          });
        });

        objDetail?.chargeOptions?.forEach((element) => {
          tempCharges.push({
            value: element.id,
            label: element.name,
          });
        });

        objDetail?.penaltyOptions?.forEach((element) => {
          tempPenaltyOptions.push({
            value: element.id,
            label: element.name,
            currencyName: element?.currency?.name,
            currencyCode: element?.currency?.code,
          });
        });

        objDetail?.accountingRuleOptions?.forEach((element) => {
          tempAccountingRuleOptions.push({
            value: element.id,
            label: element.value,
          });
        });

        objDetail?.floatingRateOptions?.forEach((element) => {
          tempFloatingRateOptions.push({
            value: element.id,
            label: element.name,
          });
        });

        objDetail?.accountingMappingOptions?.assetAccountOptions?.forEach(
          (element) => {
            tempAssetAccountOptions.push({
              value: element.id,
              label: `${element.glCode} (${element.name})`,
            });
          }
        );

        objDetail?.accountingMappingOptions?.incomeAccountOptions?.forEach(
          (element) => {
            tempIncomeAccountOptions.push({
              value: element.id,
              label: `${element.glCode} (${element.name})`,
            });
          }
        );

        objDetail?.accountingMappingOptions?.expenseAccountOptions?.forEach(
          (element) => {
            tempExpenseAccountOptions.push({
              value: element.id,
              label: `${element.glCode} (${element.name})`,
            });
          }
        );

        objDetail?.accountingMappingOptions?.liabilityAccountOptions?.forEach(
          (element) => {
            tempLiabilityAccountOptions.push({
              value: element.id,
              label: `${element.glCode} (${element.name})`,
            });
          }
        );

        objDetail?.paymentTypeOptions?.forEach((element) => {
          tempPaymentTypeOptions.push({
            value: element.id,
            label: element.name,
          });
        });

        objDetail?.repaymentFrequencyTypeOptions?.forEach((element) => {
          tempRepaymentFrequencyTypeOptions.push({
            value: element.id,
            label: element.value,
          });
        });

        objDetail?.interestRateFrequencyTypeOptions?.forEach((element) => {
          tempInterestRateFrequencyTypeOptions.push({
            value: element.id,
            label: element.value,
          });
        });

        objDetail?.valueConditionTypeOptions?.forEach((element) => {
          tempValueConditionTypeOptions.push({
            value: element.id,
            label: element.value,
          });
        });

        objDetail?.chargeOptions?.forEach((element) => {
          tempChargesOptions.push({
            value: element.id,
            label: `${element.name}(${element?.currency?.name})`,
            currencyName: element?.currency?.name,
            currencyCode: element?.currency?.code,
          });
        });

        objDetail?.interestRecalculationFrequencyTypeOptions?.forEach(
          (element) => {
            tempinterestRecalculationFrequencyTypeOptions.push({
              value: element.id,
              label: element.value,
            });
          }
        );

        objDetail?.interestRecalculationDayOfWeekTypeOptions?.forEach(
          (element) => {
            tempInterestRecalculationDayOfWeekTypeOptions.push({
              value: element.id,
              label: element.value,
            });
          }
        );

        objDetail?.interestRecalculationNthDayTypeOptions?.forEach(
          (element) => {
            tempInterestRecalculationNthDayTypeOptions.push({
              value: element.id,
              label: element.value,
            });
          }
        );

        setFundsData(tempFunds);
        setCurrencyData(tempCurrency);
        setAmortizationData(tempAmortization);
        setInterestTypeData(tempInterestType);
        setInterestCalculationPeriodTypeData(tempInterestCalculationPeriodType);
        setDaysInYearData(tempDaysInYearType);
        setDaysInMonthData(tempDaysInMonthType);
        setPreClosureInterestCalculationStrategy(
          tempPreClosureInterestCalculationStrategy
        );
        setRescheduleStrategyType(tempRescheduleStrategyType);
        setInterestRecalculationCompoundingType(
          tempInterestRecalculationCompoundingType
        );
        setRecalculationRestFrequencyType(tempRecalculationRestFrequencyType);
        setTransactionProcessingStrategyOptions(
          tempTransactionProcessingStrategy
        );
        setCharges(tempCharges);
        setAccountingRuleOptions(tempAccountingRuleOptions);
        setAssetAccountOptions(tempAssetAccountOptions);
        setIncomeAccountOptions(tempIncomeAccountOptions);
        setExpenseAccountOptions(tempExpenseAccountOptions);
        setLiabilityAccountOptions(tempLiabilityAccountOptions);
        setPaymentTypeOptions(tempPaymentTypeOptions);
        setRepaymentFrequencyTypeOptions(tempRepaymentFrequencyTypeOptions);
        setInterestRateFrequencyTypeOptions(
          tempInterestRateFrequencyTypeOptions
        );
        setValueConditionTypeOptions(tempValueConditionTypeOptions);
        setChargeOptions(tempChargesOptions);
        setPenaltyOptions(tempPenaltyOptions);
        setinterestRecalculationFrequencyTypeOptions(
          tempinterestRecalculationFrequencyTypeOptions
        );
        setInterestRecalculationDayOfWeekTypeOptions(
          tempInterestRecalculationDayOfWeekTypeOptions
        );
        setInterestRecalculationNthDayTypeOptions(
          tempInterestRecalculationNthDayTypeOptions
        );
        setChargeTableSource(tempChargesList);
        setCharges(tempCharges);
        setChargesOptions(tempChargesOptions);
        setPenaltyOptions(tempPenaltyOptions);
        setFloatingRateOptions(tempFloatingRateOptions);

        let tempChargeForTableData = tempChargesOptions.filter(
          (item) => item.currencyCode === objDetail?.currency?.code
        );

        setChargeBasedOnCurrencyList(tempChargeForTableData);
        setConfigureFundTableSource(temPaymentChannelToFundSourceMappings);
        setMapFeeTableSource(tempFeeToIncomeAccountMappings);
        setMapPenaltyTableSource(tempPenaltyToIncomeAccountMappings);
        setIsLoading(false);
      }
    });
  };

  function onCancel() {
    navigate("/prd0200", { state: state });
  }

  const handleChargeDelete = (key) => {
    let action = "Delete  ";
    let label = BOM.SubstringFormat(key.name, 20);

    Notiflix.Confirm.show(
      "Are you sure?",
      action + label,
      "Yes",
      "No",

      function () {
        const newData = chargeTableSource.filter((item) => item.id !== key.id);
        setChargeTableSource(newData);
      },

      function () {
        // No button
      }
    );
  };

  const handleFundSourceDelete = (key) => {
    let action = "Delete  ";
    let label = BOM.SubstringFormat(key.fundSourceAccountValue, 20);

    Notiflix.Confirm.show(
      "Are you sure?",
      action + label,
      "Yes",
      "No",

      function () {
        const newData = configureFundTableSource.filter(
          (item) => item.id !== key.id
        );
        setConfigureFundTableSource(newData);
      },

      function () {
        // No button
      }
    );
  };

  const handleGraceOnArrearsAging = (param) => {
    switch (param) {
      case true:
        setGraceOnArrearsAging(true);
        break;
      case false:
        setGraceOnArrearsAging(false);
        break;

      default:
        break;
    }
  };

  const handleInterestCalcPeriod = (param) => {
    switch (param) {
      case true:
        setInterestCalcPeriod(true);
        break;
      case false:
        setInterestCalcPeriod(false);
        break;

      default:
        break;
    }
  };

  const handleRepaymentFrequency = (param) => {
    switch (param) {
      case true:
        setRepaymentFrequency(true);
        break;
      case false:
        setRepaymentFrequency(false);
        break;

      default:
        break;
    }
  };

  const handleGraceOnPrincipalAndInterest = (param) => {
    switch (param) {
      case true:
        setGraceOnPrincipalAndInterest(true);
        break;
      case false:
        setGraceOnPrincipalAndInterest(false);
        break;

      default:
        break;
    }
  };

  const handleAllowAttributeConfiguration = (param) => {
    switch (param) {
      case true:
        setAllowAttributeConfiguration(true);
        break;
      case false:
        setAllowAttributeConfiguration(false);
        break;

      default:
        break;
    }
  };

  const handleAmortization = (param) => {
    switch (param) {
      case true:
        setAmortization(true);
        break;
      case false:
        setAmortization(false);
        break;

      default:
        break;
    }
  };

  const handleTransactionProcessingStrategy = (param) => {
    switch (param) {
      case true:
        setTransactionProcessingStrategy(true);
        break;
      case false:
        setTransactionProcessingStrategy(false);
        break;

      default:
        break;
    }
  };

  const handleArrearsTolerance = (param) => {
    switch (param) {
      case true:
        setArrearsTolerance(true);
        break;
      case false:
        setArrearsTolerance(false);
        break;

      default:
        break;
    }
  };

  const handleInterestMethod = (param) => {
    switch (param) {
      case true:
        setInterestMethod(true);
        break;
      case false:
        setInterestMethod(false);
        break;

      default:
        break;
    }
  };

  const handleIsLinkedToFloatingInterestRates = (param) => {
    switch (param) {
      case true:
        setIsLinkedToFloatingInterestRates(true);
        break;
      case false:
        setIsLinkedToFloatingInterestRates(false);
        break;

      default:
        break;
    }
  };

  const handleUseBorrowerCycle = (param) => {
    switch (param) {
      case true:
        setUseBorrowerCycle(true);
        break;
      case false:
        setUseBorrowerCycle(false);
        break;

      default:
        break;
    }
  };

  const handleInterestRecalculationCompounding = (param) => {
    if (param === 1 || param === 2 || param === 3) {
      setInterestRecalculationCompounding(true);
    } else {
      setInterestRecalculationCompounding(false);
    }
  };

  const handleRecalculationRestFrequency = (param) => {
    if (param === 2 || param === 3 || param === 4 || param === null) {
      setRecalculationRestFrequency(false);
    } else {
      setRecalculationRestFrequency(true);
    }

    if (param === 3) {
      setWeeklyRecalculateFrequency(true);
    } else {
      setWeeklyRecalculateFrequency(false);
    }

    if (param === 4) {
      setMonthlyRecalculateFrequency(true);
    } else {
      setMonthlyRecalculateFrequency(false);
    }
  };

  const handlePrincipalDelete = (key) => {
    let action = "Delete  ";
    let label = "Principal";

    Notiflix.Confirm.show(
      "Are you sure?",
      action + label,
      "Yes",
      "No",

      function () {
        const newData = principalByLoanCycleSource.filter(
          (item) => item.id !== key.id
        );
        setPrincipalByLoanCycleSource(newData);
      },

      function () {
        // No button
      }
    );
  };

  const handleRepaymentDelete = (key) => {
    let action = "Delete  ";
    let label = "Repayment";

    Notiflix.Confirm.show(
      "Are you sure?",
      action + label,
      "Yes",
      "No",

      function () {
        const newData = repaymentsByLoanCycleSource.filter(
          (item) => item.id !== key.id
        );
        setRepaymentsByLoanCycleSource(newData);
      },

      function () {
        // No button
      }
    );
  };

  const handleInterestRateDelete = (key) => {
    let action = "Delete  ";
    let label = "Interest Rate";

    Notiflix.Confirm.show(
      "Are you sure?",
      action + label,
      "Yes",
      "No",

      function () {
        const newData = interestRateByLoanCycleSource.filter(
          (item) => item.id !== key.id
        );
        setInterestRateByLoanCycleSource(newData);
      },

      function () {
        // No button
      }
    );
  };

  const columns = [
    [
      {
        title: "Name",
        dataIndex: "name",
      },
      {
        title: "Type",
        dataIndex: "type",
      },
      {
        title: "Amount",
        dataIndex: "amount",
      },
      {
        title: "Collected On",
        dataIndex: "collectedOn",
      },
      {
        title: "Actions",
        dataIndex: "actions",
        render: (_, record) =>
          chargeTableSource.length >= 1 ? (
            <Tooltip title={`Remove Charge`}>
              <Button
                type="primary"
                icon={<DeleteOutlined />}
                onClick={() => handleChargeDelete(record)}
                shape="round"
                size="small"
                className="of-primaryBtnColor"
              />
            </Tooltip>
          ) : null,
      },
    ],
    [
      {
        title: "Payment Type",
        //   dataIndex: "paymentTypeId",
        dataIndex: "paymentTypeValue",
      },
      {
        title: "Fund Source",
        //   dataIndex: "fundSourceAccountId",
        dataIndex: "fundSourceAccountValue",
      },
      {
        title: "Actions",
        dataIndex: "actions",
        render: (_, record) =>
          configureFundTableSource.length >= 1 ? (
            <Tooltip title={`Remove`}>
              <Button
                type="primary"
                icon={<DeleteOutlined />}
                onClick={() => handleFundSourceDelete(record)}
                shape="round"
                size="small"
                className="of-primaryBtnColor"
              />
            </Tooltip>
          ) : null,
      },
    ],
    [
      {
        title: "Fees",
        dataIndex: "chargeValue",
      },
      {
        title: "Income Account",
        dataIndex: "incomeAccountValue",
      },
      {
        title: "Actions",
        dataIndex: "actions",
        render: (_, record) =>
          mapFeeTableSource.length >= 1 ? (
            <Tooltip title={`Remove`}>
              <Button
                type="primary"
                icon={<DeleteOutlined />}
                onClick={() => handleMapFeeDelete(record)}
                shape="round"
                size="small"
                className="of-primaryBtnColor"
              />
            </Tooltip>
          ) : null,
      },
    ],
    [
      {
        title: "Penalty",
        dataIndex: "penaltyValue",
      },
      {
        title: "Income Account",
        dataIndex: "incomeAccountValue",
      },
      {
        title: "Actions",
        dataIndex: "actions",
        render: (_, record) =>
          mapPenaltyTableSource.length >= 1 ? (
            <Tooltip title={`Remove`}>
              <Button
                type="primary"
                icon={<DeleteOutlined />}
                onClick={() => handleMapPenaltyDelete(record)}
                shape="round"
                size="small"
                className="of-primaryBtnColor"
              />
            </Tooltip>
          ) : null,
      },
    ],
  ];

  const PrincipalColumns = [
    {
      title: "Principal Value Usage Condition",
      dataIndex: "principalValueUsageCondition",
    },
    {
      title: "Loan Cycle",
      dataIndex: "principalCycleNumber",
    },
    {
      title: "Minimum",
      dataIndex: "minPrincipalPerCycle",
    },
    {
      title: "Default",
      dataIndex: "PrincipalPerCycle",
    },
    {
      title: "Maximum",
      dataIndex: "maxPrincipalPerCycle",
    },
    {
      title: "Actions",
      dataIndex: "actions",
      render: (_, record) =>
        principalByLoanCycleSource.length >= 1 ? (
          <Tooltip title={`Remove`}>
            <Button
              type="primary"
              icon={<DeleteOutlined />}
              onClick={() => handlePrincipalDelete(record)}
              shape="round"
              size="small"
              className="of-primaryBtnColor"
            />
          </Tooltip>
        ) : null,
    },
  ];

  const repaymentColumns = [
    {
      title: "Repayment Value Usage Condition",
      dataIndex: "repaymentValueUsageCondition",
    },
    {
      title: "Loan Cycle",
      dataIndex: "repaymentCycleNumber",
    },
    {
      title: "Minimum",
      dataIndex: "minRepaymentPerCycle",
    },
    {
      title: "Default",
      dataIndex: "repaymentPerCycle",
    },
    {
      title: "Maximum",
      dataIndex: "maxRepaymentPerCycle",
    },
    {
      title: "Actions",
      dataIndex: "actions",
      render: (_, record) =>
        repaymentsByLoanCycleSource.length >= 1 ? (
          <Tooltip title={`Remove`}>
            <Button
              type="primary"
              icon={<DeleteOutlined />}
              onClick={() => handleRepaymentDelete(record)}
              shape="round"
              size="small"
              className="of-primaryBtnColor"
            />
          </Tooltip>
        ) : null,
    },
  ];

  const interestRateColumns = [
    {
      title: "Interest Rate Value Usage Condition",
      dataIndex: "interestRateValueUsageCondition",
    },
    {
      title: "Loan Cycle",
      dataIndex: "interestRateCycleNumber",
    },
    {
      title: "Minimum",
      dataIndex: "minInterestRatePerCycle",
    },
    {
      title: "Default",
      dataIndex: "interestRatePerCycle",
    },
    {
      title: "Maximum",
      dataIndex: "maxInterestRatePerCycle",
    },
    {
      title: "Actions",
      dataIndex: "actions",
      render: (_, record) =>
        interestRateByLoanCycleSource.length >= 1 ? (
          <Tooltip title={`Remove`}>
            <Button
              type="primary"
              icon={<DeleteOutlined />}
              onClick={() => handleInterestRateDelete(record)}
              shape="round"
              size="small"
              className="of-primaryBtnColor"
            />
          </Tooltip>
        ) : null,
    },
  ];

  const onSubmit = (formValues) => {
    let tempChargeArray = [];
    let tempPaymentChannelToFundSourceMappingsArray = [];
    let tempFeeToIncomeAccountMappingsArray = [];
    let tempPenaltyToIncomeAccountMappingsArray = [];

    chargeTableSource.forEach((element) => {
      tempChargeArray.push({
        id: element.id,
      });
    });

    configureFundTableSource.forEach((element, index) => {
      tempPaymentChannelToFundSourceMappingsArray.push({
        paymentTypeId: element.paymentTypeId,
        fundSourceAccountId: element.fundSourceAccountId,
      });
    });

    mapFeeTableSource.forEach((element, index) => {
      tempFeeToIncomeAccountMappingsArray.push({
        chargeId: element.chargeId,
        incomeAccountId: element.incomeAccountId,
      });
    });

    mapPenaltyTableSource.forEach((element, index) => {
      tempPenaltyToIncomeAccountMappingsArray.push({
        paymentTypeId: element.paymentTypeId,
        fundSourceAccountId: element.fundSourceAccountId,
      });
    });

    formValues.charges = tempChargeArray;
    formValues.paymentChannelToFundSourceMappings =
      tempPaymentChannelToFundSourceMappingsArray;
    formValues.feeToIncomeAccountMappings = tempFeeToIncomeAccountMappingsArray;
    formValues.penaltyToIncomeAccountMappings =
      tempPenaltyToIncomeAccountMappingsArray;
    formValues.startDate = formValues.startDate
      ? BOM.DateTime(formValues.startDate, "only-date")
      : formValues.startDate;
    formValues.closeDate = formValues.closeDate
      ? BOM.DateTime(formValues.closeDate, "only-date")
      : formValues.closeDate;
    delete formValues.arrearsTolerance;
    delete formValues.moratarium2;
    delete formValues.interestMethod;
    delete formValues.interestPeriod;
    delete formValues.repaidEvery;
    delete formValues.multipleDisbursals;
    delete formValues.amortization2;

    // return;

    const url = `${definedApi.EditLoanProduct}/${state.key}`;

    const body = {
      ...formValues,
      locale: "en",
      method: "PUT",
      session,
      dateFormat: "dd MMMM yyyy",
    };
    // return
    setIsLoading(true);
    BOM.FetchReqAction(body, url, (err, res) => {
      if (err) {
        BOM.AlertMsg(cnt.DANGER, err?.errors[0]?.defaultUserMessage);
        setIsLoading(false);
      } else {
        BOM.AlertMsg(cnt.SUCCESS, appLabel.editLoanProductMsg);
        navigate("/view-prd0200", { state: state });
        //STOP LOAD
        setIsLoading(false);
      }
    });
  };

  return (
    <MainLayout isEnableRightSidebar={true}>
      {/* PART 1  IMPORT TOP CONTENT*/}
      <TopContent pageTitle={"Edit Loan Product"} pageItems={[]} />
      <Spin spinning={isLoading} size="large">
        <Card
          headStyle={{ borderBottomWidth: 0 }}
          style={{
            boxShadow: "0px 0px 30px 3px rgba(0,0,0,0.1)",
            borderRadius: 20,
          }}
        >
          <Form
            initialValues={{
              active: true,
              isPenalty: false,
              // chargeAppliesTo: 2,
            }}
            form={useForm}
            layout="vertical"
            onFinish={onSubmit}
          >
            <Row>
              <Title level={4} style={{ margin: 0, marginBottom: 0 }}>
                {"Loan Product Setup"}
              </Title>
            </Row>
            <Divider style={{ marginTop: 10, marginBottom: 30 }} />
            <Row>
              <Divider orientation="left" orientationMargin="0">
                <Title level={5} style={{ margin: 0, marginBottom: 0 }}>
                  {labelConfig.generalInfo}
                </Title>
              </Divider>

              <Col span={8} style={{ padding: "0px 8px" }}>
                <Form.Item
                  label={<Text>Product Name</Text>}
                  name={"name"}
                  rules={[
                    {
                      required: true,
                      message: "Required Field",
                    },
                  ]}
                >
                  <Input placeholder="Please enter a value" />
                </Form.Item>
              </Col>

              <Col span={8} style={{ padding: "0px 8px" }}>
                <Form.Item
                  label={<Text>Short Name</Text>}
                  name={"shortName"}
                  rules={[
                    {
                      required: true,
                      message: "Required Field",
                    },
                  ]}
                >
                  <Input placeholder="Please enter a value" />
                </Form.Item>
              </Col>

              <Col span={8} style={{ padding: "0px 8px" }}>
                <Form.Item label={<Text>Fund</Text>} name={"fundId"}>
                  <Select
                    options={fundsData}
                    placeholder="Please select a value"
                    showSearch
                  />
                </Form.Item>
              </Col>

              <Col span={8} style={{ padding: "0px 8px" }}>
                <Form.Item name="startDate" label={<Text>Start Date</Text>}>
                  <DatePicker style={{ width: "100%", height: 35 }} />
                </Form.Item>
              </Col>

              <Col span={8} style={{ padding: "0px 8px" }}>
                <Form.Item name="closeDate" label={<Text>Close Date</Text>}>
                  <DatePicker style={{ width: "100%", height: 35 }} />
                </Form.Item>
              </Col>

              <Col span={8} style={{ padding: "0px 8px" }}>
                <Form.Item
                  label={"Include In Customer Loan Counter"}
                  name="includeInBorrowerCycle"
                >
                  <Select
                    filterOption={(input, option) =>
                      (option?.label?.toLowerCase() ?? "").includes(
                        input?.toLowerCase()
                      )
                    }
                    placeholder={BOM.handlePlaceholderMsg(
                      `${"Option"}`,
                      "select"
                    )}
                    options={[
                      { value: true, label: "Yes" },
                      { value: false, label: "No" },
                    ]}
                    onChange={handleIncludeInBorrowerCycle}
                    value={includeInBorrowerCycle}
                    showSearch
                  />{" "}
                </Form.Item>
              </Col>

              <Divider orientation="left" orientationMargin="0" />

              <Col span={8} style={{ padding: "0px 8px" }}>
                <Form.Item
                  label={<Text>Description</Text>}
                  name={"description"}
                  rules={[
                    {
                      type: "string",
                    },
                  ]}
                >
                  <TextArea
                    style={{ width: "45vh", height: "15vh" }}
                    placeholder="Please enter a description"
                  />
                </Form.Item>
              </Col>

              <Divider orientation="left" orientationMargin="0">
                <Title level={5} style={{ margin: 0, marginBottom: 0 }}>
                  {labelConfig.currency}
                </Title>
              </Divider>

              <Col span={8} style={{ padding: "0px 8px" }}>
                <Form.Item
                  label={<Text strong>Currency</Text>}
                  name={"currencyCode"}
                  rules={[{ required: true, message: "Required Field" }]}
                >
                  <Select
                    allowClear
                    options={currencyData}
                    placeholder="Please select a value"
                    onChange={onChange}
                  />
                </Form.Item>
              </Col>

              <Col span={8} style={{ padding: "0px 8px" }}>
                <Form.Item
                  label={<Text strong>Decimal Places</Text>}
                  name={"digitsAfterDecimal"}
                  rules={[{ required: true, message: "Required Field" }]}
                >
                  <Input placeholder="Please enter a value" />
                </Form.Item>
              </Col>

              <Col span={8} style={{ padding: "0px 8px" }}>
                <Form.Item
                  label={<Text strong>Currency In Multiples Of</Text>}
                  name={"inMultiplesOf"}
                  rules={[
                    {
                      required: true,
                      message: "Required Field",
                    },
                  ]}
                >
                  <Input placeholder="Please enter a value" />
                </Form.Item>
              </Col>

              <Col span={8} style={{ padding: "0px 8px" }}>
                <Form.Item
                  label={<Text strong>Installment In Multiples Of</Text>}
                  name={"installmentAmountInMultiplesOf"}
                  rules={[
                    {
                      required: true,
                      message: "Required Field",
                    },
                  ]}
                >
                  <Input placeholder="Please enter a value" />
                </Form.Item>
              </Col>

              <Divider orientation="left" orientationMargin="0">
                <Title level={5} style={{ margin: 0, marginBottom: 0 }}>
                  {labelConfig.terms}
                </Title>
              </Divider>
              <Row>
                <Col span={8} style={{ padding: "0px 8px" }}>
                  <Form.Item
                    label={"Terms Vary Based On Loan Cycle"}
                    name="useBorrowerCycle"
                  >
                    <Select
                      filterOption={(input, option) =>
                        (option?.label?.toLowerCase() ?? "").includes(
                          input?.toLowerCase()
                        )
                      }
                      placeholder={BOM.handlePlaceholderMsg(
                        `${"Option"}`,
                        "select"
                      )}
                      options={staticConfig.yesOrNo}
                      onChange={handleUseBorrowerCycle}
                      value={useBorrowerCycle}
                      showSearch
                    />
                  </Form.Item>
                </Col>

                <Divider orientation="left" orientationMargin="0">
                  {" "}
                  Principal
                </Divider>

                <Col span={8} style={{ padding: "0px 8px" }}>
                  <Form.Item
                    label={<Text>Minimum</Text>}
                    name={"minPrincipal"}
                    rules={[
                      {
                        required: true,
                        message: "Required Field",
                      },
                    ]}
                  >
                    <Input placeholder="minimum" />
                  </Form.Item>
                </Col>

                <Col span={8} style={{ padding: "0px 8px" }}>
                  <Form.Item label={<Text>Default</Text>} name={"principal"}>
                    <Input placeholder="Default" />
                  </Form.Item>
                </Col>

                <Col span={8} style={{ padding: "0px 8px" }}>
                  <Form.Item label={<Text>Maximum</Text>} name={"maxPrincipal"}>
                    <Input placeholder="Maximum" />
                  </Form.Item>
                </Col>

                {useBorrowerCycle ? (
                  <>
                    <PrincipalByLoanCycleModal
                      setPrincipalByLoanCycleSource={
                        setPrincipalByLoanCycleSource
                      }
                      principalByLoanCycleSource={principalByLoanCycleSource}
                      count={count}
                      setCount={setCount}
                      valueConditionTypeOptions={valueConditionTypeOptions}
                    />
                    {principalByLoanCycleSource?.length > 0 && (
                      <>
                        <Divider orientation="left" orientationMargin="0">
                          <Title
                            level={5}
                            style={{ margin: 0, marginBottom: 0 }}
                          >
                            {principalByLoanCycleSource.length > 1
                              ? "Principals by Loan Cycle "
                              : "Principal by Loan Cycle"}
                          </Title>
                        </Divider>
                        <Col span={24}>
                          <Table
                            columns={PrincipalColumns}
                            dataSource={principalByLoanCycleSource}
                            bordered
                            pagination={{
                              position: "bottomCentre",
                              pageSize: "10",
                            }}
                          />
                        </Col>
                      </>
                    )}
                  </>
                ) : null}

                <Divider orientation="left" orientationMargin="0">
                  Number Of Repayments
                </Divider>

                <Col span={8} style={{ padding: "0px 8px" }}>
                  <Form.Item
                    label={<Text>Minimum</Text>}
                    name={"minNumberOfRepayments"}
                    rules={[
                      {
                        required: true,
                        message: "Required Field",
                      },
                    ]}
                  >
                    <Input placeholder="minimum" />
                  </Form.Item>
                </Col>

                <Col span={8} style={{ padding: "0px 8px" }}>
                  <Form.Item
                    label={<Text>Default</Text>}
                    name={"numberOfRepayments"}
                  >
                    <Input placeholder="Default" />
                  </Form.Item>
                </Col>

                <Col span={8} style={{ padding: "0px 8px" }}>
                  <Form.Item
                    label={<Text>Maximum</Text>}
                    name={"maxNumberOfRepayments"}
                  >
                    <Input placeholder="Maximum" />
                  </Form.Item>
                </Col>

                {useBorrowerCycle ? (
                  <>
                    <NumberOfRepaymentsByLoanCycleModal
                      setRepaymentsByLoanCycleSource={
                        setRepaymentsByLoanCycleSource
                      }
                      repaymentsByLoanCycleSource={repaymentsByLoanCycleSource}
                      valueConditionTypeOptions={valueConditionTypeOptions}
                      count={count}
                      setCount={setCount}
                    />

                    {repaymentsByLoanCycleSource?.length > 0 && (
                      <>
                        <Divider orientation="left" orientationMargin="0">
                          <Title
                            level={5}
                            style={{ margin: 0, marginBottom: 0 }}
                          >
                            {repaymentsByLoanCycleSource.length > 1
                              ? "Repayments by Loan Cycle "
                              : "Repayment by Loan Cycle"}
                          </Title>
                        </Divider>
                        <Col span={24}>
                          <Table
                            columns={repaymentColumns}
                            dataSource={repaymentsByLoanCycleSource}
                            bordered
                            pagination={{
                              position: "bottomCentre",
                              pageSize: "10",
                            }}
                          />
                        </Col>
                      </>
                    )}
                  </>
                ) : null}

                <Divider orientation="left" orientationMargin="0">
                  Nominal Interest Rate
                </Divider>

                <Col span={8} style={{ padding: "0px 8px" }}>
                  <Form.Item
                    label={"Is Linked To Floating Interest rates?"}
                    name="isLinkedToFloatingInterestRates"
                  >
                    <Select
                      filterOption={(input, option) =>
                        (option?.label?.toLowerCase() ?? "").includes(
                          input?.toLowerCase()
                        )
                      }
                      placeholder={BOM.handlePlaceholderMsg(
                        `${"Option"}`,
                        "select"
                      )}
                      options={staticConfig.yesOrNo}
                      showSearch
                      onChange={handleIsLinkedToFloatingInterestRates}
                      value={isLinkedToFloatingInterestRates}
                    />{" "}
                  </Form.Item>
                </Col>

                {!isLinkedToFloatingInterestRates ? (
                  <>
                    <Col span={8} style={{ padding: "0px 8px" }}>
                      <Form.Item
                        label={<Text>Min. Nominal Interest Rate</Text>}
                        name={"minInterestRatePerPeriod"}
                        rules={[
                          {
                            required: true,
                            message: "Required Field",
                          },
                        ]}
                      >
                        <Input placeholder="minimum" />
                      </Form.Item>
                    </Col>

                    <Col span={8} style={{ padding: "0px 8px" }}>
                      <Form.Item
                        label={<Text>Default Nominal Interest Rate</Text>}
                        name={"interestRatePerPeriod"}
                      >
                        <Input placeholder="Default" />
                      </Form.Item>
                    </Col>

                    <Col span={8} style={{ padding: "0px 8px" }}>
                      <Form.Item
                        label={<Text>Max. Nominal Interest Rate</Text>}
                        name={"maxInterestRatePerPeriod"}
                      >
                        <Input placeholder="Maximum" />
                      </Form.Item>
                    </Col>

                    <Col span={8} style={{ padding: "0px 8px" }}>
                      <Form.Item
                        name={"interestRateFrequencyType"}
                        label={<Text>Interest Rate Frequency</Text>}
                      >
                        <Select
                          placeholder="Please select a value"
                          options={interestRateFrequencyTypeOptions}
                        />
                      </Form.Item>
                    </Col>
                  </>
                ) : (
                  <>
                    <Col span={8} style={{ padding: "0px 8px" }}>
                      <Form.Item
                        label={<Text>Floating Interest Rate</Text>}
                        name={"floatingrateoptions"}
                      >
                        <Select
                          placeholder="Please select a value"
                          options={floatingRateOptions}
                        />
                      </Form.Item>
                    </Col>

                    <Col span={8} style={{ padding: "0px 8px" }}>
                      <Form.Item
                        label={<Text>Differential Interest</Text>}
                        name={"differentialinterest"}
                      >
                        <Input placeholder="Differential Interest" />
                      </Form.Item>
                    </Col>

                    <Col span={8} style={{ padding: "0px 8px" }}>
                      <Form.Item label={<Text>Minimum</Text>} name={"minValue"}>
                        <Input placeholder="Minimum" />
                      </Form.Item>
                    </Col>

                    <Col span={8} style={{ padding: "0px 8px" }}>
                      <Form.Item label={<Text>Default</Text>} name={"default"}>
                        <Input placeholder="Default" />
                      </Form.Item>
                    </Col>

                    <Col span={8} style={{ padding: "0px 8px" }}>
                      <Form.Item label={<Text>Maximum</Text>} name={"maxValue"}>
                        <Input placeholder="Maximum" />
                      </Form.Item>
                    </Col>
                    <Col span={8} style={{ padding: "0px 8px" }}>
                      <Form.Item
                        label={"Is Floating Calculation Allowed?"}
                        name="isFloatingInterestRateCalculationAllowed"
                      >
                        <Select
                          filterOption={(input, option) =>
                            (option?.label?.toLowerCase() ?? "").includes(
                              input?.toLowerCase()
                            )
                          }
                          placeholder={BOM.handlePlaceholderMsg(
                            `${"Option"}`,
                            "select"
                          )}
                          options={[
                            { value: true, label: "Yes" },
                            { value: false, label: "No" },
                          ]}
                          showSearch
                        />{" "}
                      </Form.Item>
                    </Col>
                  </>
                )}

                {useBorrowerCycle ? (
                  <>
                    <InterestRateByLoanCycleModal
                      setInterestRateByLoanCycleSource={
                        setInterestRateByLoanCycleSource
                      }
                      interestRateByLoanCycleSource={
                        interestRateByLoanCycleSource
                      }
                      valueConditionTypeOptions={valueConditionTypeOptions}
                      count={count}
                      setCount={setCount}
                    />

                    {interestRateByLoanCycleSource?.length > 0 && (
                      <>
                        <Divider orientation="left" orientationMargin="0">
                          <Title
                            level={5}
                            style={{ margin: 0, marginBottom: 0 }}
                          >
                            {interestRateByLoanCycleSource.length > 1
                              ? "Interest Rates by Loan Cycle "
                              : "Interest Rate by Loan Cycle"}
                          </Title>
                        </Divider>
                        <Col span={24}>
                          <Table
                            columns={interestRateColumns}
                            dataSource={interestRateByLoanCycleSource}
                            bordered
                            pagination={{
                              position: "bottomCentre",
                              pageSize: "10",
                            }}
                          />
                        </Col>
                      </>
                    )}
                  </>
                ) : null}

                <Col span={8} style={{ padding: "0px 8px" }}>
                  <Form.Item
                    label={<Text>Repaid Every</Text>}
                    name={"repaymentEvery"}
                    rules={[
                      {
                        required: true,
                        message: "Required Field",
                      },
                    ]}
                  >
                    <Input placeholder="Please enter a value" />
                  </Form.Item>
                </Col>

                <Col span={8} style={{ padding: "0px 8px" }}>
                  <Form.Item
                    name={"repaymentFrequencyType"}
                    label={<Text>Repayment Frequency </Text>}
                  >
                    <Select
                      options={repaymentFrequencyTypeOptions}
                      placeholder="Please select a value"
                    />
                  </Form.Item>
                </Col>

                <Col span={8} style={{ padding: "0px 8px" }}>
                  <Form.Item
                    label={
                      <Tooltip
                        title={
                          "Minimum Days Between Disbursal And First Repayment Date"
                        }
                      >
                        {BOM.SubstringFormat(
                          "Minimum Days Between Disbursal And First Repayment Date",
                          25
                        )}
                      </Tooltip>
                    }
                    name={"minimumDaysBetweenDisbursalAndFirstRepayment"}
                  >
                    <Input placeholder="Minimum" />
                  </Form.Item>
                </Col>
              </Row>

              <Divider orientation="left" orientationMargin="0">
                <Title level={5} style={{ margin: 0, marginBottom: 0 }}>
                  {"Settings"}
                </Title>
              </Divider>

              <Row style={{ justifyContent: "space-between" }}>
                <Col span={8} style={{ padding: "0px 8px" }}>
                  <Form.Item
                    label={<Text>Amortization</Text>}
                    name={"amortizationType"}
                    rules={[
                      {
                        required: true,
                        message: "Required Field",
                      },
                    ]}
                  >
                    <Select
                      options={amortizationData}
                      placeholder="Please select a value"
                    />
                  </Form.Item>
                </Col>

                <Col span={8} style={{ padding: "0px 8px" }}>
                  <Form.Item
                    label={<Text>Interest Method</Text>}
                    name={"interestType"}
                    rules={[
                      {
                        required: true,
                        message: "Required Field",
                      },
                    ]}
                  >
                    <Select
                      options={interestTypeData}
                      placeholder="Please select a value"
                    />
                  </Form.Item>
                </Col>

                <Col span={8} style={{ padding: "0px 8px" }}>
                  <Form.Item
                    label={"Is Equal Amortization"}
                    name="isEqualAmortization"
                  >
                    <Select
                      filterOption={(input, option) =>
                        (option?.label?.toLowerCase() ?? "").includes(
                          input?.toLowerCase()
                        )
                      }
                      placeholder={BOM.handlePlaceholderMsg(
                        `${"Option"}`,
                        "select"
                      )}
                      options={staticConfig.yesOrNo}
                      onChange={handleIsEqualAmortization}
                      value={isEqualAmortization}
                      showSearch
                    />{" "}
                  </Form.Item>
                </Col>

                <Col span={8} style={{ padding: "0px 8px" }}>
                  <Form.Item
                    label={<Text>Interest Calculation Period</Text>}
                    name={"interestCalculationPeriodType"}
                    rules={[
                      {
                        required: true,
                        message: "Required Field",
                      },
                    ]}
                  >
                    <Select
                      options={interestCalculationPeriodTypeData}
                      placeholder="Please select a value"
                      onChange={onRepaymentPeriodSelect}
                    />
                  </Form.Item>
                </Col>
                {repaymentPeriod && (
                  <>
                    <Col span={8} style={{ padding: "0px 8px" }}>
                      <Form.Item
                        label={
                          <Tooltip
                            title={
                              "Calculate interest for exact days in partial period"
                            }
                          >
                            {BOM.SubstringFormat(
                              "Calculate interest for exact days in partial period",
                              25
                            )}
                          </Tooltip>
                        }
                        name="allowPartialPeriodInterestCalcualtion"
                      >
                        <Select
                          filterOption={(input, option) =>
                            (option?.label?.toLowerCase() ?? "").includes(
                              input?.toLowerCase()
                            )
                          }
                          placeholder={BOM.handlePlaceholderMsg(
                            `${"Option"}`,
                            "select"
                          )}
                          options={[
                            { value: true, label: "Yes" },
                            { value: false, label: "No" },
                          ]}
                          showSearch
                        />{" "}
                      </Form.Item>
                    </Col>
                  </>
                )}

                <Col span={8} style={{ padding: "0px 8px" }}>
                  <Form.Item
                    label={<Text>Repayment Strategy</Text>}
                    name={"transactionProcessingStrategyId"}
                    rules={[{ required: true, message: "Required Field" }]}
                  >
                    <Select
                      options={transactionProcessingStrategyOptions}
                      placeholder="Please select a value"
                    />
                  </Form.Item>
                </Col>

                <Col span={8} style={{ padding: "0px 8px" }}>
                  <Form.Item
                    label={<Text>Moratorium</Text>}
                    name={"graceOnPrincipalPayment"}
                  >
                    <Input placeholder="On Principal Payment" />
                  </Form.Item>
                </Col>

                <Col span={8} style={{ padding: "0px 8px" }}>
                  <Form.Item
                    label={<Text>Grace On Interest Payment</Text>}
                    name={"graceOnInterestPayment"}
                  >
                    <Input placeholder="On Interest Payment" />
                  </Form.Item>
                </Col>

                <Col span={8} style={{ padding: "0px 8px" }}>
                  <Form.Item
                    label={<Text>Interest Free Period</Text>}
                    name={"graceOnInterestCharged"}
                  >
                    <Input placeholder="Please enter a value" />
                  </Form.Item>
                </Col>

                <Col span={8} style={{ padding: "0px 8px" }}>
                  <Form.Item
                    label={<Text>Arrears Tolerance</Text>}
                    name={"inArrearsTolerance"}
                  >
                    <Input placeholder="Please enter a value" />
                  </Form.Item>
                </Col>

                <Col span={8} style={{ padding: "0px 8px" }}>
                  <Form.Item
                    label={<Text>Days In Year</Text>}
                    name={"daysInYearType"}
                    rules={[
                      {
                        required: true,
                        message: "Required Field",
                      },
                    ]}
                  >
                    <Select
                      options={daysInYearData}
                      placeholder="Please select a value"
                    />
                  </Form.Item>
                </Col>

                <Col span={8} style={{ padding: "0px 8px" }}>
                  <Form.Item
                    label={<Text>Days In Month</Text>}
                    name={"daysInMonthType"}
                    rules={[
                      {
                        required: true,
                        message: "Required Field",
                      },
                    ]}
                  >
                    <Select
                      options={daysInMonthData}
                      placeholder="Please select a value"
                    />
                  </Form.Item>
                </Col>

                <Col span={8} style={{ padding: "0px 8px" }}>
                  <Form.Item
                    label={"Allow Fixing Of The Installment Amount"}
                    name="canDefineInstallmentAmount"
                  >
                    <Select
                      filterOption={(input, option) =>
                        (option?.label?.toLowerCase() ?? "").includes(
                          input?.toLowerCase()
                        )
                      }
                      placeholder={BOM.handlePlaceholderMsg(
                        `${"Option"}`,
                        "select"
                      )}
                      options={staticConfig.yesOrNo}
                      value={canDefineInstallmentAmount}
                      onChange={handleCanDefineInstallmentAmount}
                      showSearch
                    />{" "}
                  </Form.Item>
                </Col>

                <Col span={8} style={{ padding: "0px 8px" }}>
                  <Form.Item
                    label={
                      <Tooltip
                        title={
                          "Number of days a loan may be overdue before moving into arrears"
                        }
                      >
                        {BOM.SubstringFormat(
                          "Number of days a loan may be overdue before moving into arrears",
                          25
                        )}
                      </Tooltip>
                    }
                    name={"graceOnArrearsAgeing"}
                  >
                    <Input placeholder="Please enter a value" />
                  </Form.Item>
                </Col>

                <Col span={8} style={{ padding: "0px 8px" }}>
                  <Form.Item
                    label={
                      <Tooltip
                        title={
                          "Maximum number of days a loan may be overdue before becoming a NPA (non performing asset)"
                        }
                      >
                        {BOM.SubstringFormat(
                          "Maximum number of days a loan may be overdue before becoming a NPA (non performing asset)",
                          25
                        )}
                      </Tooltip>
                    }
                    name={"overdueDaysForNPA"}
                  >
                    <Input placeholder="Please enter a value" />
                  </Form.Item>
                </Col>

                <Col span={8} style={{ padding: "0px 8px" }}>
                  <Form.Item
                    label={
                      <Tooltip
                        title={
                          "Account moves out of NPA only after all arrears have been cleared?"
                        }
                      >
                        {BOM.SubstringFormat(
                          "Account moves out of NPA only after all arrears have been cleared?",
                          25
                        )}
                      </Tooltip>
                    }
                    name="accountMovesOutOfNPAOnlyOnArrearsCompletion"
                  >
                    <Select
                      filterOption={(input, option) =>
                        (option?.label?.toLowerCase() ?? "").includes(
                          input?.toLowerCase()
                        )
                      }
                      placeholder={BOM.handlePlaceholderMsg(
                        `${"Option"}`,
                        "select"
                      )}
                      options={staticConfig.yesOrNo}
                      value={accountMovesOutOfNPAOnlyOnArrearsCompletion}
                      onChange={
                        handleAccountMovesOutOfNPAOnlyOnArrearsCompletion
                      }
                      showSearch
                    />{" "}
                  </Form.Item>
                </Col>

                <Col span={8} style={{ padding: "0px 8px" }}>
                  <Form.Item
                    label={
                      <Text>Principal Threshold (%) for Last Installment</Text>
                    }
                    name={"principalThresholdForLastInstallment"}
                  >
                    <Input placeholder="Please enter a value" />
                  </Form.Item>
                </Col>

                <Col span={8} style={{ padding: "0px 8px" }}>
                  <Form.Item
                    label={"Is Variable Installments Allowed?"}
                    name="allowVariableInstallments"
                  >
                    <Select
                      filterOption={(input, option) =>
                        (option?.label?.toLowerCase() ?? "").includes(
                          input?.toLowerCase()
                        )
                      }
                      placeholder={BOM.handlePlaceholderMsg(
                        `${"Option"}`,
                        "select"
                      )}
                      options={staticConfig.yesOrNo}
                      showSearch
                    />
                  </Form.Item>
                </Col>

                {variableInstallmentsChecked && (
                  <>
                    <Col span={8} style={{ padding: "0px 8px" }}>
                      <Form.Item
                        label={<Text>Variable Installments</Text>}
                        name={"minimumGap"}
                        rules={[{ required: true, message: "Required Field" }]}
                      >
                        <Input placeholder="Minimum gap between" />
                      </Form.Item>
                    </Col>

                    <Col span={8} style={{ padding: "0px 8px" }}>
                      <Form.Item
                        label={<Text hidden>Variable Installments</Text>}
                        name={"maximumGap"}
                      >
                        <Input placeholder="Maximum gap between" />
                      </Form.Item>
                    </Col>
                  </>
                )}

                <Col span={8} style={{ padding: "0px 8px" }}>
                  <Form.Item
                    label={
                      <Tooltip
                        title={
                          "Is allowed to be used for providing Topup Loans?"
                        }
                      >
                        {BOM.SubstringFormat(
                          "Is allowed to be used for providing Topup Loans?",
                          25
                        )}
                      </Tooltip>
                    }
                    name="canUseForTopup"
                  >
                    <Select
                      filterOption={(input, option) =>
                        (option?.label?.toLowerCase() ?? "").includes(
                          input?.toLowerCase()
                        )
                      }
                      placeholder={BOM.handlePlaceholderMsg(
                        `${"Option"}`,
                        "select"
                      )}
                      options={staticConfig.yesOrNo}
                      value={canUseForTopup}
                      onChange={handleCanUseForTopup}
                      showSearch
                    />{" "}
                  </Form.Item>
                </Col>

                <Col span={8} style={{ padding: "0px 8px" }}></Col>

                <Divider orientation="left" orientationMargin="0">
                  Interest Recalculation
                </Divider>

                <Col span={8} style={{ padding: "0px 8px" }}>
                  <Form.Item
                    label={"Recalculate Interest"}
                    name="isInterestRecalculationEnabled"
                  >
                    <Select
                      filterOption={(input, option) =>
                        (option?.label?.toLowerCase() ?? "").includes(
                          input?.toLowerCase()
                        )
                      }
                      placeholder={BOM.handlePlaceholderMsg(
                        `${"Option"}`,
                        "select"
                      )}
                      options={staticConfig.yesOrNo}
                      showSearch
                    />
                  </Form.Item>
                </Col>

                {recalculateInterestCheck ? (
                  <>
                    <Col span={8} style={{ padding: "0px 8px" }}>
                      <Form.Item
                        label={
                          <Text>Pre-closure Interest Calculation Rule</Text>
                        }
                        name={"preClosureInterestCalculationStrategy"}
                        rules={[
                          {
                            required: true,
                            message: "Required Field",
                          },
                        ]}
                      >
                        <Select
                          options={preClosureInterestCalculationStrategy}
                          placeholder="Please select a value"
                        />
                      </Form.Item>
                    </Col>

                    <Col span={8} style={{ padding: "0px 8px" }}>
                      <Form.Item
                        label={<Text>Advance Payments Adjustment Type</Text>}
                        name={"rescheduleStrategyMethod"}
                        rules={[
                          {
                            required: true,
                            message: "Required Field",
                          },
                        ]}
                      >
                        <Select
                          options={rescheduleStrategyType}
                          placeholder="Please select a value"
                        />
                      </Form.Item>
                    </Col>

                    <Col span={8} style={{ padding: "0px 8px" }}>
                      <Form.Item
                        label={
                          <Text>Interest Recalculation Compounding On</Text>
                        }
                        name={"interestRecalculationCompoundingMethod"}
                        rules={[
                          {
                            required: true,
                            message: "Required Field",
                          },
                        ]}
                      >
                        <Select
                          options={interestRecalculationCompoundingType}
                          placeholder="Please select a value"
                          onChange={handleInterestRecalculationCompounding}
                        />
                      </Form.Item>
                    </Col>

                    {interestRecalculationCompounding && (
                      <>
                        <Col span={8} style={{ padding: "0px 8px" }}>
                          <Form.Item
                            label={<Text>Frequency For Compounding</Text>}
                            name={"recalculationCompoundingFrequencyType"}
                            rules={[
                              {
                                required: true,
                                message: "Required Field",
                              },
                            ]}
                          >
                            <Select
                              options={
                                interestRecalculationFrequencyTypeOptions
                              }
                              placeholder="Please select a value"
                            />
                          </Form.Item>
                        </Col>

                        <Col span={8} style={{ padding: "0px 8px" }}>
                          <Form.Item
                            label={
                              <Text>Frequency Interval for Compounding</Text>
                            }
                            name={"recalculationCompoundingFrequencyInterval"}
                            rules={[
                              {
                                required: true,
                                message: "Required Field",
                              },
                            ]}
                          >
                            <Input placeholder="Please enter a value" />
                          </Form.Item>
                        </Col>
                      </>
                    )}

                    <Col span={8} style={{ padding: "0px 8px" }}>
                      <Form.Item
                        label={
                          <Tooltip
                            title={
                              "Frequency for recalculate Outstanding Principal"
                            }
                          >
                            {BOM.SubstringFormat(
                              "Frequency for recalculate Outstanding Principal",
                              25
                            )}
                          </Tooltip>
                        }
                        name={"recalculationRestFrequencyType"}
                        rules={[
                          {
                            required: true,
                            message: "Required Field",
                          },
                        ]}
                      >
                        <Select
                          options={recalculationRestFrequencyType}
                          placeholder="Please select a value"
                          onChange={handleRecalculationRestFrequency}
                        />
                      </Form.Item>
                    </Col>

                    {weeklyRecalculateFrequency && (
                      <Col span={8} style={{ padding: "0px 8px" }}>
                        <Form.Item
                          label={"Recalculation Frequency Day Of Week"}
                          name={"recalculationRestFrequencyDayOfWeekType"}
                          rules={[
                            {
                              required: true,
                              message: "Required Field",
                            },
                          ]}
                        >
                          <Select
                            options={interestRecalculationDayOfWeekTypeOptions}
                            placeholder="Please select a value"
                          />
                        </Form.Item>
                      </Col>
                    )}

                    {monthlyRecalculateFrequency && (
                      <>
                        <Col span={8} style={{ padding: "0px 8px" }}>
                          <Form.Item
                            label={"Recalculation Frequency Day"}
                            name={"recalculationRestFrequencyNthDayType"}
                            rules={[
                              {
                                required: true,
                                message: "Required Field",
                              },
                            ]}
                          >
                            <Select
                              options={interestRecalculationNthDayTypeOptions}
                              placeholder="Please select a value"
                            />
                          </Form.Item>
                        </Col>
                        <Col span={8} style={{ padding: "0px 8px" }}>
                          <Form.Item
                            label={"Recalculation Frequency Day Of Week"}
                            name={"recalculationRestFrequencyDayOfWeekType"}
                            rules={[
                              {
                                required: true,
                                message: "Required Field",
                              },
                            ]}
                          >
                            <Select
                              options={
                                interestRecalculationDayOfWeekTypeOptions
                              }
                              placeholder="Please select a value"
                            />
                          </Form.Item>
                        </Col>
                      </>
                    )}

                    <Col span={8} style={{ padding: "0px 8px" }}>
                      <Form.Item
                        label={
                          <Text>Frequency Interval for Recalculation</Text>
                        }
                        name={"recalculationRestFrequencyInterval"}
                        hidden={recalculationRestFrequency}
                        rules={[
                          {
                            required: true,
                            message: "Required Field",
                          },
                        ]}
                      >
                        <Input placeholder="Please enter a value" />
                      </Form.Item>
                    </Col>

                    <Col span={8} style={{ padding: "0px 8px" }}>
                      <Form.Item
                        label={
                          <Tooltip
                            title={
                              "Is Arrears recognization based on original schedule"
                            }
                          >
                            {BOM.SubstringFormat(
                              "Is Arrears recognization based on original schedule",
                              25
                            )}
                          </Tooltip>
                        }
                        name="isArrearsBasedOnOriginalSchedule"
                      >
                        <Select
                          filterOption={(input, option) =>
                            (option?.label?.toLowerCase() ?? "").includes(
                              input?.toLowerCase()
                            )
                          }
                          placeholder={BOM.handlePlaceholderMsg(
                            `${"Option"}`,
                            "select"
                          )}
                          options={[
                            { value: true, label: "Yes" },
                            { value: false, label: "No" },
                          ]}
                          onChange={handleIsArrearsBasedOnOriginalSchedule}
                          showSearch
                        />{" "}
                      </Form.Item>
                    </Col>
                  </>
                ) : null}

                <Divider orientation="left" orientationMargin="0">
                  Guarantee Requirements
                </Divider>

                <Col span={8} style={{ padding: "0px 8px" }}>
                  <Form.Item
                    label={"Place Guarantee Funds On-Hold?"}
                    name="holdGuaranteeFunds"
                  >
                    <Select
                      filterOption={(input, option) =>
                        (option?.label?.toLowerCase() ?? "").includes(
                          input?.toLowerCase()
                        )
                      }
                      placeholder={BOM.handlePlaceholderMsg(
                        `${"Option"}`,
                        "select"
                      )}
                      options={staticConfig.yesOrNo}
                      showSearch
                    />
                  </Form.Item>
                </Col>

                {guaranteeRequirementsCheck ? (
                  <>
                    <Col span={8} style={{ padding: "0px 8px" }}>
                      <Form.Item
                        label={<Text>Mandatory Guarantee(%)</Text>}
                        name={"mandatoryGuarantee"}
                        rules={[{ required: true, message: "Required Field" }]}
                      >
                        <Input placeholder="Please enter a value" />
                      </Form.Item>
                    </Col>

                    <Col span={8} style={{ padding: "0px 8px" }}>
                      <Form.Item
                        label={<Text>Minimum Guarantee from Own Funds(%)</Text>}
                        name={"minimumGuaranteeFromOwnFunds"}
                        rules={[{ required: true, message: "Required Field" }]}
                      >
                        <Input placeholder="Please enter a value" />
                      </Form.Item>
                    </Col>

                    <Col span={8} style={{ padding: "0px 8px" }}>
                      <Form.Item
                        label={
                          <Text>
                            Minimum Guarantee from Guarantors Funds(%)
                          </Text>
                        }
                        name={"minimumGuaranteeFromGuarantor"}
                        rules={[{ required: true, message: "Required Field" }]}
                      >
                        <Input placeholder="Please enter a value" />
                      </Form.Item>
                    </Col>
                  </>
                ) : null}

                <Divider orientation="left" orientationMargin="0">
                  Configurable Terms and Settings
                </Divider>

                <Col span={8} style={{ padding: "0px 8px" }}>
                  <Form.Item
                    label={
                      <Tooltip
                        title={
                          "Allow overriding select terms and settings in loan accounts"
                        }
                      >
                        {BOM.SubstringFormat(
                          "Allow overriding select terms and settings in loan accounts",
                          25
                        )}
                      </Tooltip>
                    }
                    name="allowAttributeConfiguration"
                  >
                    <Select
                      filterOption={(input, option) =>
                        (option?.label?.toLowerCase() ?? "").includes(
                          input?.toLowerCase()
                        )
                      }
                      placeholder={BOM.handlePlaceholderMsg(
                        `${"Option"}`,
                        "select"
                      )}
                      options={staticConfig.yesOrNo}
                      onChange={handleAllowAttributeConfiguration}
                      value={allowAttributeConfiguration}
                      showSearch
                    />
                    {""}
                  </Form.Item>
                </Col>

                {allowAttributeConfiguration ? (
                  <>
                    <Col span={8} style={{ padding: "0px 8px" }}>
                      <Form.Item label={"Amortization"} name="amortization">
                        <Select
                          filterOption={(input, option) =>
                            (option?.label?.toLowerCase() ?? "").includes(
                              input?.toLowerCase()
                            )
                          }
                          placeholder={BOM.handlePlaceholderMsg(
                            `${"Option"}`,
                            "select"
                          )}
                          options={[
                            { value: true, label: "Yes" },
                            { value: false, label: "No" },
                          ]}
                          onChange={handleAmortization}
                          value={amortization}
                          showSearch
                        />{" "}
                      </Form.Item>
                    </Col>

                    <Col span={8} style={{ padding: "0px 8px" }}>
                      <Form.Item
                        label={"Repayment strategy"}
                        name="transactionProcessingStrategy"
                      >
                        <Select
                          filterOption={(input, option) =>
                            (option?.label?.toLowerCase() ?? "").includes(
                              input?.toLowerCase()
                            )
                          }
                          placeholder={BOM.handlePlaceholderMsg(
                            `${"Option"}`,
                            "select"
                          )}
                          options={[
                            { value: true, label: "Yes" },
                            { value: false, label: "No" },
                          ]}
                          onChange={handleTransactionProcessingStrategy}
                          value={transactionProcessingStrategy}
                          showSearch
                        />{" "}
                      </Form.Item>
                    </Col>

                    <Col span={8} style={{ padding: "0px 8px" }}>
                      <Form.Item
                        label={"Arrears Tolerance"}
                        name="arrearsTolerance"
                      >
                        <Select
                          filterOption={(input, option) =>
                            (option?.label?.toLowerCase() ?? "").includes(
                              input?.toLowerCase()
                            )
                          }
                          placeholder={BOM.handlePlaceholderMsg(
                            `${"Option"}`,
                            "select"
                          )}
                          options={[
                            { value: true, label: "Yes" },
                            { value: false, label: "No" },
                          ]}
                          onChange={handleArrearsTolerance}
                          value={arrearsTolerance}
                          showSearch
                        />{" "}
                      </Form.Item>
                    </Col>

                    <Col span={8} style={{ padding: "0px 8px" }}>
                      <Form.Item
                        label={"Moratarium"}
                        name="graceOnPrincipalAndInterest"
                      >
                        <Select
                          filterOption={(input, option) =>
                            (option?.label?.toLowerCase() ?? "").includes(
                              input?.toLowerCase()
                            )
                          }
                          placeholder={BOM.handlePlaceholderMsg(
                            `${"Option"}`,
                            "select"
                          )}
                          options={[
                            { value: true, label: "Yes" },
                            { value: false, label: "No" },
                          ]}
                          onChange={handleGraceOnPrincipalAndInterest}
                          value={graceOnPrincipalAndInterest}
                          showSearch
                        />{" "}
                      </Form.Item>
                    </Col>

                    <Col span={8} style={{ padding: "0px 8px" }}>
                      <Form.Item
                        label={"Interest Method"}
                        name="interestMethod"
                      >
                        <Select
                          filterOption={(input, option) =>
                            (option?.label?.toLowerCase() ?? "").includes(
                              input?.toLowerCase()
                            )
                          }
                          placeholder={BOM.handlePlaceholderMsg(
                            `${"Option"}`,
                            "select"
                          )}
                          options={[
                            { value: true, label: "Yes" },
                            { value: false, label: "No" },
                          ]}
                          onChange={handleInterestMethod}
                          value={interestMethod}
                          showSearch
                        />{" "}
                      </Form.Item>
                    </Col>

                    <Col span={8} style={{ padding: "0px 8px" }}>
                      <Form.Item
                        label={"Interest Calculation Period"}
                        name="interestCalcPeriod"
                      >
                        <Select
                          filterOption={(input, option) =>
                            (option?.label?.toLowerCase() ?? "").includes(
                              input?.toLowerCase()
                            )
                          }
                          placeholder={BOM.handlePlaceholderMsg(
                            `${"Option"}`,
                            "select"
                          )}
                          options={[
                            { value: true, label: "Yes" },
                            { value: false, label: "No" },
                          ]}
                          onChange={handleInterestCalcPeriod}
                          value={interestCalcPeriod}
                          showSearch
                        />{" "}
                      </Form.Item>
                    </Col>

                    <Col span={8} style={{ padding: "0px 8px" }}>
                      <Form.Item
                        label={"Repaid every"}
                        name="repaymentFrequency"
                      >
                        <Select
                          filterOption={(input, option) =>
                            (option?.label?.toLowerCase() ?? "").includes(
                              input?.toLowerCase()
                            )
                          }
                          placeholder={BOM.handlePlaceholderMsg(
                            `${"Option"}`,
                            "select"
                          )}
                          options={[
                            { value: true, label: "Yes" },
                            { value: false, label: "No" },
                          ]}
                          onChange={handleRepaymentFrequency}
                          value={repaymentFrequency}
                          showSearch
                        />{" "}
                      </Form.Item>
                    </Col>

                    <Col span={8} style={{ padding: "0px 8px" }}>
                      <Form.Item
                        label={
                          <Tooltip
                            title={
                              "Number of days a loan may be overdue before moving into arrears"
                            }
                          >
                            {BOM.SubstringFormat(
                              "Number of days a loan may be overdue before moving into arrears",
                              25
                            )}
                          </Tooltip>
                        }
                        name="graceOnArrearsAging"
                      >
                        <Select
                          filterOption={(input, option) =>
                            (option?.label?.toLowerCase() ?? "").includes(
                              input?.toLowerCase()
                            )
                          }
                          placeholder={BOM.handlePlaceholderMsg(
                            `${"Option"}`,
                            "select"
                          )}
                          options={[
                            { value: true, label: "Yes" },
                            { value: false, label: "No" },
                          ]}
                          onChange={handleGraceOnArrearsAging}
                          value={graceOnArrearsAging}
                          showSearch
                        />{" "}
                      </Form.Item>
                    </Col>
                  </>
                ) : null}

                <Divider orientation="left" orientationMargin="0">
                  Loan Tranche Details
                </Divider>

                <Col span={8} style={{ padding: "0px 8px" }}>
                  <Form.Item
                    label={"Enable Multiple Disbursals "}
                    name="multiDisburseLoan"
                  >
                    <Select
                      filterOption={(input, option) =>
                        (option?.label?.toLowerCase() ?? "").includes(
                          input?.toLowerCase()
                        )
                      }
                      placeholder={BOM.handlePlaceholderMsg(
                        `${"Option"}`,
                        "select"
                      )}
                      options={staticConfig.yesOrNo}
                      showSearch
                    />
                  </Form.Item>
                </Col>

                {multipleDisbursalsCheck ? (
                  <>
                    <Col span={8} style={{ padding: "0px 8px" }}>
                      <Form.Item
                        label={<Text>Maximum Tranche Count </Text>}
                        name={"maxTrancheCount"}
                        rules={[{ required: true, message: "Required Field" }]}
                      >
                        <Input />
                      </Form.Item>
                    </Col>

                    <Col span={8} style={{ padding: "0px 8px" }}>
                      <Form.Item
                        label={<Text>Maximum Allowed Outstanding Balance</Text>}
                        name={"outstandingLoanBalance"}
                        rules={[{ required: true, message: "Required Field" }]}
                      >
                        <Input />
                      </Form.Item>
                    </Col>
                  </>
                ) : null}
              </Row>
            </Row>

            <Divider orientation="left" orientationMargin="0">
              <Title level={5} style={{ margin: 0, marginBottom: 0 }}>
                {labelConfig.chargeInfo}
              </Title>
            </Divider>
            <ChargeModal
              isChargeModalOpen={isChargeModalOpen}
              isLoading={isLoading}
              setIsLoading={setIsLoading}
              setIsChargeModalOpen={setIsChargeModalOpen}
              chargeData={chargeBasedOnCurrencyList}
              setChargeList={setChargeList}
              setChargeTableSource={setChargeTableSource}
              chargeTableSource={chargeTableSource}
              chargeList={chargeList}
              session={session}
            />

            {chargeTableSource?.length > 0 && (
              <>
                <Divider orientation="left" orientationMargin="0">
                  <Title level={5} style={{ margin: 0, marginBottom: 0 }}>
                    {chargeTableSource.length > 1
                      ? labelConfig.selectedCharges
                      : labelConfig.selectedCharge}
                  </Title>
                </Divider>
                <Table
                  columns={columns[0]}
                  dataSource={chargeTableSource}
                  bordered
                  pagination={{
                    position: "bottomCentre",
                    pageSize: "10",
                  }}
                />
              </>
            )}
            <Divider orientation="left" orientationMargin="0">
              <Title level={5} style={{ margin: 0, marginBottom: 0 }}>
                {"Accounting Information"}
              </Title>
            </Divider>
            <div>
              <Row>
                <Divider orientation="left" orientationMargin="0">
                  {" "}
                  Assests
                </Divider>
                <Col span={8} style={{ padding: "0px 8px" }}>
                  <Form.Item
                    name="fundSourceAccountId"
                    label={<Text strong> Fund Source</Text>}
                  >
                    <Select
                      options={assetAccountOptions}
                      placeholder={"Select an Option"}
                      showSearch
                    />
                  </Form.Item>
                </Col>

                <Col span={8} style={{ padding: "0px 8px" }}>
                  <Form.Item
                    name="loanPortfolioAccountId"
                    label={<Text strong>Loan Portfolio</Text>}
                  >
                    <Select
                      options={assetAccountOptions}
                      placeholder={"Select an Option"}
                      showSearch
                    />
                  </Form.Item>
                </Col>

                <Col span={8} style={{ padding: "0px 8px" }}>
                  <Form.Item
                    name="transfersInSuspenseAccountId"
                    label={<Text strong>Transfer In Suspense</Text>}
                  >
                    <Select
                      options={assetAccountOptions}
                      placeholder={"Select an Option"}
                      showSearch
                    />
                  </Form.Item>
                </Col>

                <Divider orientation="left" orientationMargin="0">
                  {" "}
                  Income
                </Divider>

                <Col span={8} style={{ padding: "0px 8px" }}>
                  <Form.Item
                    name="interestOnLoanAccountId"
                    label={<Text strong>Income From Interest</Text>}
                  >
                    <Select
                      options={incomeAccountOptions}
                      placeholder={"Select an Option"}
                      showSearch
                    />
                  </Form.Item>
                </Col>
                <Col span={8} style={{ padding: "0px 8px" }}>
                  <Form.Item
                    name="incomeFromFeeAccountId"
                    label={<Text strong>Income From Fees</Text>}
                  >
                    <Select
                      options={incomeAccountOptions}
                      placeholder={"Select an Option"}
                      showSearch
                    />
                  </Form.Item>
                </Col>
                <Col span={8} style={{ padding: "0px 8px" }}>
                  <Form.Item
                    name="incomeFromPenaltyAccountId"
                    label={<Text strong>Income From Penalties</Text>}
                  >
                    <Select
                      options={incomeAccountOptions}
                      placeholder={"Select an Option"}
                      showSearch
                    />
                  </Form.Item>
                </Col>
                <Col span={8} style={{ padding: "0px 8px" }}>
                  <Form.Item
                    name="incomeFromRecoveryAccountId"
                    label={<Text strong>Income From Recovery Payments</Text>}
                  >
                    <Select
                      options={incomeAccountOptions}
                      placeholder={"Select an Option"}
                      showSearch
                    />
                  </Form.Item>
                </Col>

                <Divider orientation="left" orientationMargin="0">
                  {" "}
                  Expenses
                </Divider>

                <Col span={8} style={{ padding: "0px 8px" }}>
                  <Form.Item
                    name="writeOffAccountId"
                    label={<Text strong>Losses Written Off</Text>}
                  >
                    <Select
                      options={expenseAccountOptions}
                      placeholder={"Select an Option"}
                      showSearch
                    />
                  </Form.Item>
                </Col>

                <Divider orientation="left" orientationMargin="0">
                  {" "}
                  Liabilities
                </Divider>

                <Col span={8} style={{ padding: "0px 8px" }}>
                  <Form.Item
                    name="overpaymentLiabilityAccountId"
                    label={<Text strong>Overpayment Liability</Text>}
                  >
                    <Select
                      options={liabilityAccountOptions}
                      placeholder={"Select an Option"}
                      showSearch
                    />
                  </Form.Item>
                </Col>
              </Row>
              <Divider orientation="left" orientationMargin="0">
                Advanced Accounting Rule:{" "}
                <span>
                  {showAdvancedAccounting ? (
                    <>
                      <Button
                        type="dashed"
                        onClick={() =>
                          setShowAdvancedAccounting(!showAdvancedAccounting)
                        }
                        icon={<DownOutlined />}
                      >
                        Hide
                      </Button>
                    </>
                  ) : (
                    <>
                      <Button
                        type="dashed"
                        onClick={() =>
                          setShowAdvancedAccounting(!showAdvancedAccounting)
                        }
                        icon={<RightOutlined />}
                      >
                        Show
                      </Button>
                    </>
                  )}
                </span>
              </Divider>
              {/* <Divider style={{ margin: 0, padding: 0 }} /> */}
              {showAdvancedAccounting && (
                <div>
                  <Divider orientation="left" orientationMargin="0">
                    <Title level={5} style={{ margin: 0, marginBottom: 0 }}>
                      Configure Fund Sources for Payment Channels
                    </Title>
                  </Divider>
                  <FundSourceModal
                    isFundSourceModalOpen={isFundSourceModalOpen}
                    isLoading={isLoading}
                    setIsLoading={setIsLoading}
                    setIsFundSourceModalOpen={setIsFundSourceModalOpen}
                    paymentTypeOptions={paymentTypeOptions}
                    assetAccountOptions={assetAccountOptions}
                    setConfigureFundTableSource={setConfigureFundTableSource}
                    configureFundTableSource={configureFundTableSource}
                    session={session}
                    fundCount={fundCount}
                    setFundCount={setFundCount}
                  />

                  {configureFundTableSource?.length > 0 && (
                    <>
                      <Divider orientation="left" orientationMargin="0">
                        <Title level={5} style={{ margin: 0, marginBottom: 0 }}>
                          {configureFundTableSource.length > 1
                            ? "Selected Fund Sources"
                            : "Selected Fund Source"}
                        </Title>
                      </Divider>
                      <Table
                        columns={columns[1]}
                        dataSource={configureFundTableSource}
                        bordered
                        pagination={{
                          position: "bottomCentre",
                          pageSize: "10",
                        }}
                      />
                    </>
                  )}
                  <Divider orientation="left" orientationMargin="0">
                    <Title level={5} style={{ margin: 0, marginBottom: 0 }}>
                      Map Fees to Income Accounts
                    </Title>
                  </Divider>
                  <MapFeeModal
                    isMapFeeModalOpen={isMapFeeModalOpen}
                    isLoading={isLoading}
                    setIsLoading={setIsLoading}
                    setIsMapFeeeModalOpen={setIsMapFeeeModalOpen}
                    charges={charges}
                    incomeAccountOptions={incomeAccountOptions}
                    setMapFeeTableSource={setMapFeeTableSource}
                    mapFeeTableSource={mapFeeTableSource}
                    session={session}
                    feeCount={feeCount}
                    setFeeCount={setFeeCount}
                  />

                  {mapFeeTableSource?.length > 0 && (
                    <>
                      <Divider orientation="left" orientationMargin="0">
                        <Title level={5} style={{ margin: 0, marginBottom: 0 }}>
                          {mapFeeTableSource.length > 1
                            ? "Selected Income Accounts"
                            : "Selected Income Account"}
                        </Title>
                      </Divider>
                      <Table
                        columns={columns[2]}
                        dataSource={mapFeeTableSource}
                        bordered
                        pagination={{
                          position: "bottomCentre",
                          pageSize: "10",
                        }}
                      />
                    </>
                  )}
                </div>
              )}
            </div>
            <Row>
              <Divider />
              {BOM.HasPermission("UPDATE_LOANPRODUCT") && (
                <CustomButton
                  content="Submit"
                  style={{
                    width: "10%",
                    marginLeft: "auto",
                    boxShadow: "0px 0px 10px 5px rgba(0,0,0,0.1)",
                  }}
                  htmlType="submit"
                  backgroundColor="#92428B"
                  colorText="white"
                  hoverBackground="#AD4EA7"
                />
              )}
              <CustomButton
                content="Cancel"
                style={{
                  width: "10%",
                  marginLeft: "1%",
                  boxShadow: "0px 0px 10px 5px rgba(0,0,0,0.1)",
                }}
                backgroundColor="#fff"
                colorText="black"
                hoverBackground="#F5F5F5"
                onClick={onCancel}
              />
            </Row>
          </Form>
        </Card>
      </Spin>
    </MainLayout>
  );
};
export default EditLoanProduct;

const ChargeModal = (props) => {
  const {
    session,
    isLoading,
    setIsLoading,
    setChargeTableSource,
    chargeTableSource,
    isChargeModalOpen,
    chargeData,
    setIsChargeModalOpen,
    setChargeList,
    chargeList,
  } = props;

  const [useForm] = Form.useForm();

  const showModal = () => {
    setIsChargeModalOpen(true);
  };
  const handleOk = () => {
    setIsChargeModalOpen(false);
  };
  const handleCancel = () => {
    setIsChargeModalOpen(false);
  };

  const handleChargeSave = (formValues) => {
    const newCharges = {
      key: formValues?.chargeId,
      id: formValues?.chargeId,
      name: formValues.name,
      type: formValues.type,
      collectedOn: formValues.collectedOn,
      amountToUse: formValues?.amount,
      amount: (
        <Statistic
          value={formValues?.amount}
          precision={2}
          valueStyle={{ fontSize: "16px" }}
        />
      ),
    };

    // console.log(chargeTableSource);
    let foundCharge = chargeTableSource.find(
      (item) => item.id === newCharges?.id
    );
    if (foundCharge) {
      BOM.AlertMsg(cnt.WARNING, "No duplicate Charge allowed!");
      return;
    }
    setChargeTableSource([...chargeTableSource, newCharges]);

    useForm.resetFields();
  };

  const handleSelectedCharge = (chargeId) => {
    // console.log(chargeId);
    const params = {
      template: "true",
    };

    const url = `${apiConfig.charges}/${chargeId}`;

    const body = {
      session,
      params,
    };

    setIsLoading(true);
    BOM.FetchReqAction(body, url, (err, res) => {
      if (err) {
        BOM.AlertMsg(cnt.DANGER, err.defaultUserMessage);
      } else {
        const objDetail = res;

        useForm.setFieldsValue({
          key: objDetail.id,
          id: objDetail.id,
          name: objDetail.name,
          type: objDetail.chargeCalculationType.value,
          collectedOn: objDetail?.chargeTimeType.value,
          amount: objDetail?.amount,
        });

        // STOP LOAD
        setIsLoading(false);
      }
    });
  };

  return (
    <Row>
      <Button
        type="primary"
        onClick={showModal}
        icon={<PlusOutlined />}
        style={{
          boxShadow: "0px 0px 10px 5px rgba(0,0,0,0.1)",
          backgroundColor: "#92428B",
          marginBottom: 20,
        }}
      >
        {labelConfig.addCharge}
      </Button>

      <Modal
        title="Charge Information Setup"
        open={isChargeModalOpen}
        okText="Add"
        cancelText="Cancel"
        okButtonProps={{
          autoFocus: true,
          htmlType: "submit",
          style: {
            ...styles.ofPrimaryBtnColor,
          },
        }}
        centered
        onCancel={handleCancel}
        width={800}
        modalRender={(dom) => (
          <Form
            form={useForm}
            layout="vertical"
            onFinish={handleChargeSave}
            name="address-info"
          >
            {dom}
          </Form>
        )}
        style={{
          height: 600,
          overflow: "auto",
        }}
      >
        <Spin spinning={isLoading} tip="Loading..." size="large">
          <Row>
            <Divider />

            <Col span={12} style={{ padding: "0px 8px" }}>
              <Form.Item
                name={"chargeId"}
                label={"Charge Options"}
                rules={[
                  {
                    required: true,
                    message: BOM.CheckReqFld(labelConfig.charge),
                  },
                ]}
              >
                <Select
                  filterOption={(input, option) =>
                    (option?.label?.toLowerCase() ?? "").includes(
                      input?.toLowerCase()
                    )
                  }
                  placeholder={BOM.handlePlaceholderMsg(
                    labelConfig.charge,
                    "select"
                  )}
                  options={chargeData}
                  onChange={handleSelectedCharge}
                  style={{ width: "30vh" }}
                  showSearch
                />
              </Form.Item>
            </Col>
          </Row>
          <Row>
            <Divider />
            <Col span={12} style={{ padding: "0px 8px" }}>
              <Form.Item label={labelConfig.name} name={"name"}>
                <Input
                  disabled
                  className="of-bold-disable-input"
                  placeholder={BOM.handlePlaceholderMsg(labelConfig.name)}
                />
              </Form.Item>
            </Col>
            <Col span={12} style={{ padding: "0px 8px" }}>
              <Form.Item label={labelConfig.type} name={"type"}>
                <Input
                  disabled
                  className="of-bold-disable-input"
                  placeholder={BOM.handlePlaceholderMsg(labelConfig.type)}
                />
              </Form.Item>
            </Col>
            <Col span={12} style={{ padding: "0px 8px" }}>
              <Form.Item label={labelConfig.collectedOn} name={"collectedOn"}>
                <Input
                  disabled
                  className="of-bold-disable-input"
                  placeholder={BOM.handlePlaceholderMsg(
                    labelConfig.collectedOn
                  )}
                />
              </Form.Item>
            </Col>
            <Col span={12} style={{ padding: "0px 8px" }}>
              <Form.Item label={labelConfig.amount} name={"amount"}>
                <Input
                  disabled
                  className="of-bold-disable-input"
                  placeholder={BOM.handlePlaceholderMsg(labelConfig.amount)}
                />
              </Form.Item>
            </Col>
          </Row>
        </Spin>
      </Modal>
    </Row>
  );
};

const FundSourceModal = (props) => {
  const {
    session,
    isLoading,
    setIsLoading,
    setConfigureFundTableSource,
    configureFundTableSource,
    isFundSourceModalOpen,
    setIsFundSourceModalOpen,
    paymentTypeOptions,
    assetAccountOptions,
    fundCount,
    setFundCount,
  } = props;

  const [useForm] = Form.useForm();

  const showModal = () => {
    setIsFundSourceModalOpen(true);
  };
  const handleOk = () => {
    setIsFundSourceModalOpen(false);
  };
  const handleCancel = () => {
    setIsFundSourceModalOpen(false);
  };

  const handleFundSourceSave = (formValues) => {
    const newCharges = {
      key: fundCount,
      id: fundCount,
      fundSourceAccountId: formValues.fundSourceAccountId,
      paymentTypeId: formValues.paymentTypeId,
      paymentTypeValue: paymentTypeOptions.find(
        (item) => item.value === formValues.paymentTypeId
      ).label,
      fundSourceAccountValue: assetAccountOptions.find(
        (item) => item.value === formValues.fundSourceAccountId
      ).label,
    };
    setFundCount(fundCount + 1);
    setConfigureFundTableSource([...configureFundTableSource, newCharges]);

    useForm.resetFields();
  };

  return (
    <Row>
      <Button
        type="primary"
        onClick={showModal}
        icon={<PlusOutlined />}
        style={{
          boxShadow: "0px 0px 10px 5px rgba(0,0,0,0.1)",
          backgroundColor: "#92428B",
          marginBottom: 20,
        }}
      >
        {"Add Fund Source"}
      </Button>

      <Modal
        title="Fund Source Information Setup"
        open={isFundSourceModalOpen}
        okText="Add"
        cancelText="Cancel"
        okButtonProps={{
          autoFocus: true,
          htmlType: "submit",
          style: {
            ...styles.ofPrimaryBtnColor,
          },
        }}
        centered
        onCancel={handleCancel}
        width={800}
        modalRender={(dom) => (
          <Form
            form={useForm}
            layout="vertical"
            onFinish={handleFundSourceSave}
            name="address-info"
          >
            {dom}
          </Form>
        )}
        style={{
          height: 600,
          overflow: "auto",
        }}
      >
        <Spin spinning={isLoading} tip="Loading..." size="large">
          <Row>
            <Divider />

            <Col span={12} style={{ padding: "0px 8px" }}>
              <Form.Item
                name={"paymentTypeId"}
                label={"Payment Type"}
                rules={[
                  {
                    required: true,
                    message: BOM.CheckReqFld("Payment Type"),
                  },
                ]}
              >
                <Select
                  filterOption={(input, option) =>
                    (option?.label?.toLowerCase() ?? "").includes(
                      input?.toLowerCase()
                    )
                  }
                  placeholder={BOM.handlePlaceholderMsg(
                    "Payment Type",
                    "select"
                  )}
                  options={paymentTypeOptions}
                  allowClear
                  showSearch
                />
              </Form.Item>
            </Col>
            <Col span={12} style={{ padding: "0px 8px" }}>
              <Form.Item
                name={"fundSourceAccountId"}
                label={"Fund Source"}
                rules={[
                  {
                    required: true,
                    message: BOM.CheckReqFld("Fund Source"),
                  },
                ]}
              >
                <Select
                  filterOption={(input, option) =>
                    (option?.label?.toLowerCase() ?? "").includes(
                      input?.toLowerCase()
                    )
                  }
                  placeholder={BOM.handlePlaceholderMsg(
                    "Fund Source",
                    "select"
                  )}
                  options={assetAccountOptions}
                  allowClear
                  showSearch
                />
              </Form.Item>
            </Col>
          </Row>
        </Spin>
      </Modal>
    </Row>
  );
};

const MapFeeModal = (props) => {
  const {
    session,
    isLoading,
    setIsLoading,
    setMapFeeTableSource,
    mapFeeTableSource,
    isMapFeeModalOpen,
    setIsMapFeeeModalOpen,
    charges,
    incomeAccountOptions,
    feeCount,
    setFeeCount,
  } = props;

  const [useForm] = Form.useForm();

  const showModal = () => {
    setIsMapFeeeModalOpen(true);
  };
  const handleOk = () => {
    setIsMapFeeeModalOpen(false);
  };
  const handleCancel = () => {
    setIsMapFeeeModalOpen(false);
  };

  const handleMapFeeSave = (formValues) => {
    const newCharges = {
      key: feeCount,
      id: feeCount,
      incomeAccountId: formValues.incomeAccountId,
      chargeId: formValues.chargeId,
      chargeValue: charges.find((item) => item.value === formValues.chargeId)
        .label,
      incomeAccountValue: incomeAccountOptions.find(
        (item) => item.value === formValues.incomeAccountId
      ).label,
    };

    setFeeCount(feeCount + 1);
    setMapFeeTableSource([...mapFeeTableSource, newCharges]);

    useForm.resetFields();
  };

  return (
    <Row>
      <Button
        type="primary"
        onClick={showModal}
        icon={<PlusOutlined />}
        style={{
          boxShadow: "0px 0px 10px 5px rgba(0,0,0,0.1)",
          backgroundColor: "#92428B",
          marginBottom: 20,
        }}
      >
        {"Add Income Account"}
      </Button>

      <Modal
        title="Income Account Information Setup"
        open={isMapFeeModalOpen}
        okText="Add"
        cancelText="Cancel"
        okButtonProps={{
          autoFocus: true,
          htmlType: "submit",
          style: {
            ...styles.ofPrimaryBtnColor,
          },
        }}
        centered
        onCancel={handleCancel}
        width={800}
        modalRender={(dom) => (
          <Form
            form={useForm}
            layout="vertical"
            onFinish={handleMapFeeSave}
            name="address-info"
          >
            {dom}
          </Form>
        )}
        style={{
          height: 600,
          overflow: "auto",
        }}
      >
        <Spin spinning={isLoading} tip="Loading..." size="large">
          <Row>
            <Divider />

            <Col span={12} style={{ padding: "0px 8px" }}>
              <Form.Item
                name={"chargeId"}
                label={"Fees"}
                rules={[
                  {
                    required: true,
                    message: BOM.CheckReqFld("Fees"),
                  },
                ]}
              >
                <Select
                  filterOption={(input, option) =>
                    (option?.label?.toLowerCase() ?? "").includes(
                      input?.toLowerCase()
                    )
                  }
                  placeholder={BOM.handlePlaceholderMsg("Fees", "select")}
                  options={charges}
                  //   onChange={handleSelectedCharge}
                  allowClear
                  showSearch
                />
              </Form.Item>
            </Col>
            <Col span={12} style={{ padding: "0px 8px" }}>
              <Form.Item
                name={"incomeAccountId"}
                label={"Income Account"}
                rules={[
                  {
                    required: true,
                    message: BOM.CheckReqFld("Income Account"),
                  },
                ]}
              >
                <Select
                  filterOption={(input, option) =>
                    (option?.label?.toLowerCase() ?? "").includes(
                      input?.toLowerCase()
                    )
                  }
                  placeholder={BOM.handlePlaceholderMsg(
                    "Income Account",
                    "select"
                  )}
                  options={incomeAccountOptions}
                  //   onChange={handleSelectedCharge}
                  allowClear
                  showSearch
                />
              </Form.Item>
            </Col>
          </Row>
        </Spin>
      </Modal>
    </Row>
  );
};

const MapPenaltyModal = (props) => {
  const {
    session,
    isLoading,
    setIsLoading,
    setMapPenaltyTableSource,
    mapPenaltyTableSource,
    isMapPenaltyModalOpen,
    setIsMapPenaltyModalOpen,
    penaltyOptions,
    incomeAccountOptions,
    penaltyCount,
    setPenaltyCount,
  } = props;

  const [useForm] = Form.useForm();

  const showModal = () => {
    setIsMapPenaltyModalOpen(true);
  };
  const handleOk = () => {
    setIsMapPenaltyModalOpen(false);
  };
  const handleCancel = () => {
    setIsMapPenaltyModalOpen(false);
  };

  const handleMapPenaltySave = (formValues) => {
    const newCharges = {
      key: penaltyCount,
      id: penaltyCount,
      incomeAccountPenalty: formValues.incomeAccountPenalty,
      penalty: formValues.penalty,
      penaltyValue: penaltyOptions.find(
        (item) => item.value === formValues.penalty
      ).label,
      incomeAccountValue: incomeAccountOptions.find(
        (item) => item.value === formValues.incomeAccountPenalty
      ).label,
    };
    setPenaltyCount(penaltyCount + 1);
    setMapPenaltyTableSource([...mapPenaltyTableSource, newCharges]);

    useForm.resetFields();
  };

  return (
    <Row>
      <Button
        type="primary"
        onClick={showModal}
        icon={<PlusOutlined />}
        style={{
          boxShadow: "0px 0px 10px 5px rgba(0,0,0,0.1)",
          backgroundColor: "#92428B",
          marginBottom: 20,
        }}
      >
        {"Add Income Account"}
      </Button>

      <Modal
        title="Income Account Information Setup"
        open={isMapPenaltyModalOpen}
        okText="Add"
        cancelText="Cancel"
        okButtonProps={{
          autoFocus: true,
          htmlType: "submit",
          style: {
            ...styles.ofPrimaryBtnColor,
          },
        }}
        centered
        onCancel={handleCancel}
        width={800}
        modalRender={(dom) => (
          <Form
            form={useForm}
            layout="vertical"
            onFinish={handleMapPenaltySave}
            name="address-info"
          >
            {dom}
          </Form>
        )}
        style={{
          height: 600,
          overflow: "auto",
        }}
      >
        <Spin spinning={isLoading} tip="Loading..." size="large">
          <Row>
            <Divider />

            <Col span={12} style={{ padding: "0px 8px" }}>
              <Form.Item
                name={"penalty"}
                label={"Penalty"}
                rules={[
                  {
                    required: true,
                    message: BOM.CheckReqFld("Penalty"),
                  },
                ]}
              >
                <Select
                  filterOption={(input, option) =>
                    (option?.label?.toLowerCase() ?? "").includes(
                      input?.toLowerCase()
                    )
                  }
                  placeholder={BOM.handlePlaceholderMsg("Penalty", "select")}
                  options={penaltyOptions}
                  //   onChange={handleSelectedCharge}
                  allowClear
                  showSearch
                />
              </Form.Item>
            </Col>
            <Col span={12} style={{ padding: "0px 8px" }}>
              <Form.Item
                name={"incomeAccountPenalty"}
                label={"Income Account"}
                rules={[
                  {
                    required: true,
                    message: BOM.CheckReqFld("Income Account"),
                  },
                ]}
              >
                <Select
                  filterOption={(input, option) =>
                    (option?.label?.toLowerCase() ?? "").includes(
                      input?.toLowerCase()
                    )
                  }
                  placeholder={BOM.handlePlaceholderMsg(
                    "Income Account",
                    "select"
                  )}
                  options={incomeAccountOptions}
                  //   onChange={handleSelectedCharge}
                  allowClear
                  showSearch
                />
              </Form.Item>
            </Col>
          </Row>
        </Spin>
      </Modal>
    </Row>
  );
};

const PrincipalByLoanCycleModal = (props) => {
  const {
    session,
    setPrincipalByLoanCycleSource,
    principalByLoanCycleSource,
    valueConditionTypeOptions,
    assetAccountOptions,
    count,
    setCount,
    handleFundSourceDelete,
  } = props;

  const [useForm] = Form.useForm();
  const [isLoading, setIsLoading] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);

  const showModal = () => {
    setIsModalOpen(true);
  };
  const handleOk = () => {
    setIsModalOpen(false);
  };
  const handleCancel = () => {
    setIsModalOpen(false);
  };

  const handlePrincipalByLoanCycleSave = (formValues) => {
    const newPrincipal = {
      key: count,
      id: count,
      principalCycleNumber: formValues.principalCycleNumber,
      principalValueUsageCondition: valueConditionTypeOptions.find(
        (item) => item.value === formValues.principalValueUsageCondition
      ).label,
      principalValueUsageConditionId: valueConditionTypeOptions.find(
        (item) => item.value === formValues.principalValueUsageCondition
      ).value,
      minPrincipalPerCycle: formValues.minPrincipalPerCycle,
      PrincipalPerCycle: formValues.PrincipalPerCycle,
      maxPrincipalPerCycle: formValues.maxPrincipalPerCycle,
    };
    setCount(count + 1);
    setPrincipalByLoanCycleSource([
      ...principalByLoanCycleSource,
      newPrincipal,
    ]);

    useForm.resetFields();
  };

  return (
    <Row>
      <Form.Item label={<Text>Principal By Loan Cycle</Text>}>
        <Button
          type="primary"
          onClick={showModal}
          icon={<PlusOutlined />}
          style={{
            boxShadow: "0px 0px 10px 5px rgba(0,0,0,0.1)",
            backgroundColor: "#92428B",
            marginBottom: 20,
          }}
          shape="round"
        >
          {"Add"}
        </Button>
      </Form.Item>
      <Modal
        title="Principal By Loan Cycle Setup"
        open={isModalOpen}
        okText="Add"
        cancelText="Cancel"
        okButtonProps={{
          autoFocus: true,
          htmlType: "submit",
          style: {
            ...styles.ofPrimaryBtnColor,
          },
        }}
        centered
        onCancel={handleCancel}
        width={800}
        modalRender={(dom) => (
          <Form
            form={useForm}
            layout="vertical"
            onFinish={handlePrincipalByLoanCycleSave}
            name="address-info"
          >
            {dom}
          </Form>
        )}
        style={{
          height: 600,
          overflow: "auto",
        }}
      >
        <Spin spinning={isLoading} tip="Loading..." size="large">
          <Row>
            <Divider />

            <Col span={8} style={{ padding: "0px 8px" }}>
              <Form.Item
                name={"principalValueUsageCondition"}
                label={"Principal Value Usage Condition"}
              >
                <Select
                  filterOption={(input, option) =>
                    (option?.label?.toLowerCase() ?? "").includes(
                      input?.toLowerCase()
                    )
                  }
                  placeholder={BOM.handlePlaceholderMsg(
                    "Principal Value Usage Condition",
                    "select"
                  )}
                  options={valueConditionTypeOptions}
                  allowClear
                  showSearch
                />
              </Form.Item>
            </Col>
            <Col span={8} style={{ padding: "0px 8px" }}>
              <Form.Item
                label={<Text>Loan Cycle</Text>}
                name={"principalCycleNumber"}
              >
                <Input placeholder="Please enter a value" />
              </Form.Item>
            </Col>
            <Col span={8} style={{ padding: "0px 8px" }}>
              <Form.Item
                label={<Text>Minimum Principal per Cycle</Text>}
                name={"minPrincipalPerCycle"}
              >
                <Input placeholder="Please enter a value" />
              </Form.Item>
            </Col>
            <Col span={8} style={{ padding: "0px 8px" }}>
              <Form.Item
                label={<Text>Principal per Cycle</Text>}
                name={"PrincipalPerCycle"}
              >
                <Input placeholder="Please enter a value" />
              </Form.Item>
            </Col>
            <Col span={8} style={{ padding: "0px 8px" }}>
              <Form.Item
                label={<Text>Maximim Principal per Cycle</Text>}
                name={"maxPrincipalPerCycle"}
              >
                <Input placeholder="Please enter a value" />
              </Form.Item>
            </Col>
          </Row>
        </Spin>
      </Modal>
    </Row>
  );
};

const NumberOfRepaymentsByLoanCycleModal = (props) => {
  const {
    session,
    setRepaymentsByLoanCycleSource,
    repaymentsByLoanCycleSource,
    valueConditionTypeOptions,
    assetAccountOptions,
    count,
    setCount,
    handleFundSourceDelete,
  } = props;

  const [useForm] = Form.useForm();
  const [isLoading, setIsLoading] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);

  const showModal = () => {
    setIsModalOpen(true);
  };
  const handleOk = () => {
    setIsModalOpen(false);
  };
  const handleCancel = () => {
    setIsModalOpen(false);
  };

  const handleRepaymentsByLoanCycleSave = (formValues) => {
    const newNumberOfRepayment = {
      key: count,
      id: count,
      repaymentValueUsageCondition: valueConditionTypeOptions.find(
        (item) => item.value === formValues.repaymentValueUsageCondition
      ).label,
      repaymentValueUsageConditionId: valueConditionTypeOptions.find(
        (item) => item.value === formValues.repaymentValueUsageCondition
      ).value,
      repaymentCycleNumber: formValues.repaymentCycleNumber,
      minRepaymentPerCycle: formValues.minRepaymentPerCycle,
      repaymentPerCycle: formValues.repaymentPerCycle,
      maxRepaymentPerCycle: formValues.maxRepaymentPerCycle,
    };
    setCount(count + 1);
    setRepaymentsByLoanCycleSource([
      ...repaymentsByLoanCycleSource,
      newNumberOfRepayment,
    ]);

    useForm.resetFields();
  };

  return (
    <Row>
      <Form.Item label={<Text>Repayments By Loan Cycle</Text>}>
        <Button
          type="primary"
          onClick={showModal}
          icon={<PlusOutlined />}
          style={{
            boxShadow: "0px 0px 10px 5px rgba(0,0,0,0.1)",
            backgroundColor: "#92428B",
            marginBottom: 20,
          }}
          shape="round"
        >
          {"Add"}
        </Button>
      </Form.Item>

      <Modal
        title="Repayments By Loan Cycle Setup"
        open={isModalOpen}
        okText="Add"
        cancelText="Cancel"
        okButtonProps={{
          autoFocus: true,
          htmlType: "submit",
          style: {
            ...styles.ofPrimaryBtnColor,
          },
        }}
        centered
        onCancel={handleCancel}
        width={800}
        modalRender={(dom) => (
          <Form
            form={useForm}
            layout="vertical"
            onFinish={handleRepaymentsByLoanCycleSave}
            name="address-info"
          >
            {dom}
          </Form>
        )}
        style={{
          height: 600,
          overflow: "auto",
        }}
      >
        <Spin spinning={isLoading} tip="Loading..." size="large">
          <Row>
            <Divider />

            <Col span={8} style={{ padding: "0px 8px" }}>
              <Form.Item
                name={"repaymentValueUsageCondition"}
                label={"Repayment Value Usage Condition"}
              >
                <Select
                  filterOption={(input, option) =>
                    (option?.label?.toLowerCase() ?? "").includes(
                      input?.toLowerCase()
                    )
                  }
                  placeholder={BOM.handlePlaceholderMsg(
                    "Repayment Value Usage Condition",
                    "select"
                  )}
                  options={valueConditionTypeOptions}
                  allowClear
                  showSearch
                />
              </Form.Item>
            </Col>
            <Col span={8} style={{ padding: "0px 8px" }}>
              <Form.Item
                label={<Text>Minimum Principal per Cycle</Text>}
                name={"repaymentCycleNumber"}
              >
                <Input placeholder="Please enter a value" />
              </Form.Item>
            </Col>
            <Col span={8} style={{ padding: "0px 8px" }}>
              <Form.Item
                label={<Text>Repayment per Cycle</Text>}
                name={"minRepaymentPerCycle"}
              >
                <Input placeholder="Please enter a value" />
              </Form.Item>
            </Col>
            <Col span={8} style={{ padding: "0px 8px" }}>
              <Form.Item
                label={<Text>Repayment per Cycle</Text>}
                name={"repaymentPerCycle"}
              >
                <Input placeholder="Please enter a value" />
              </Form.Item>
            </Col>
            <Col span={8} style={{ padding: "0px 8px" }}>
              <Form.Item
                label={<Text>Maximim Repayment per Cycle</Text>}
                name={"maxRepaymentPerCycle"}
              >
                <Input placeholder="Please enter a value" />
              </Form.Item>
            </Col>
          </Row>
        </Spin>
      </Modal>
    </Row>
  );
};

const InterestRateByLoanCycleModal = (props) => {
  const {
    session,
    setInterestRateByLoanCycleSource,
    interestRateByLoanCycleSource,
    valueConditionTypeOptions,
    assetAccountOptions,
    count,
    setCount,
    handleFundSourceDelete,
  } = props;

  const [useForm] = Form.useForm();
  const [isLoading, setIsLoading] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);

  const showModal = () => {
    setIsModalOpen(true);
  };
  const handleOk = () => {
    setIsModalOpen(false);
  };
  const handleCancel = () => {
    setIsModalOpen(false);
  };

  const handleInterestRateSave = (formValues) => {
    const newInterestRate = {
      key: count,
      id: count,
      interestRateValueUsageCondition: valueConditionTypeOptions.find(
        (item) => item.value === formValues.interestRateValueUsageCondition
      ).label,
      interestRateValueUsageConditionId: valueConditionTypeOptions.find(
        (item) => item.value === formValues.interestRateValueUsageCondition
      ).value,
      interestRateCycleNumber: formValues.interestRateCycleNumber,
      minInterestRatePerCycle: formValues.minInterestRatePerCycle,
      interestRatePerCycle: formValues.interestRatePerCycle,
      maxInterestRatePerCycle: formValues.maxInterestRatePerCycle,
    };
    setCount(count + 1);
    setInterestRateByLoanCycleSource([
      ...interestRateByLoanCycleSource,
      newInterestRate,
    ]);

    useForm.resetFields();
  };

  return (
    <Row>
      <Form.Item label={<Text>Interest Rate By Loan Cycle</Text>}>
        <Button
          type="primary"
          onClick={showModal}
          icon={<PlusOutlined />}
          style={{
            boxShadow: "0px 0px 10px 5px rgba(0,0,0,0.1)",
            backgroundColor: "#92428B",
            marginBottom: 20,
          }}
          shape="round"
        >
          {"Add"}
        </Button>
      </Form.Item>
      <Modal
        title="Interest Rate By Loan Cycle Setup"
        open={isModalOpen}
        okText="Add"
        cancelText="Cancel"
        okButtonProps={{
          autoFocus: true,
          htmlType: "submit",
          style: {
            ...styles.ofPrimaryBtnColor,
          },
        }}
        centered
        onCancel={handleCancel}
        width={800}
        modalRender={(dom) => (
          <Form
            form={useForm}
            layout="vertical"
            onFinish={handleInterestRateSave}
            name="address-info"
          >
            {dom}
          </Form>
        )}
        style={{
          height: 600,
          overflow: "auto",
        }}
      >
        <Spin spinning={isLoading} tip="Loading..." size="large">
          <Row>
            <Divider />

            <Col span={8} style={{ padding: "0px 8px" }}>
              <Form.Item
                name={"interestRateValueUsageCondition"}
                label={"Rate Value Usage Condition"}
              >
                <Select
                  filterOption={(input, option) =>
                    (option?.label?.toLowerCase() ?? "").includes(
                      input?.toLowerCase()
                    )
                  }
                  placeholder={BOM.handlePlaceholderMsg(
                    "Interest Rate Value Usage Condition",
                    "select"
                  )}
                  options={valueConditionTypeOptions}
                  allowClear
                  showSearch
                />
              </Form.Item>
            </Col>
            <Col span={8} style={{ padding: "0px 8px" }}>
              <Form.Item
                label={<Text>Interest Rate Cycle Number</Text>}
                name={"interestRateCycleNumber"}
              >
                <Input placeholder="Please enter a value" />
              </Form.Item>
            </Col>
            <Col span={8} style={{ padding: "0px 8px" }}>
              <Form.Item
                label={<Text>Minimum Interest Rate per Cycle</Text>}
                name={"minInterestRatePerCycle"}
              >
                <Input placeholder="Please enter a value" />
              </Form.Item>
            </Col>
            <Col span={8} style={{ padding: "0px 8px" }}>
              <Form.Item
                label={<Text>Interest Rate per Cycle</Text>}
                name={"interestRatePerCycle"}
              >
                <Input placeholder="Please enter a value" />
              </Form.Item>
            </Col>
            <Col span={8} style={{ padding: "0px 8px" }}>
              <Form.Item
                label={<Text>Maximim Interest Rate per Cycle</Text>}
                name={"maxInterestRatePerCycle"}
              >
                <Input placeholder="Please enter a value" />
              </Form.Item>
            </Col>
          </Row>
        </Spin>
      </Modal>
    </Row>
  );
};
